class BooyaTranslations {
    languages = {
        ENGLISH: 'en',
        SPANISH: 'es',
        FRENCH: 'fr',
    }

    phrases = {
        ACCOUNT_CREATED_CHECK_INBOX: '🎉 Account created successfully! Please check your inbox for instructions.',
        ACCOUNT_EXISTS: '❌ An account with this email already exists.',
        ACCOUNT_VERIFICATION_SENT: '🎉 A verification email has been sent to {email}. Please check your inbox for instructions.',
        ACCOUNT_RECOVERY: 'Account Recovery',
        ACCOUNT_VERIFICATION_COMPLETE: '🎉 Account verification complete.',
        ALREADY_HAVE_ACCOUNT: 'Already have an account?',
        BACK_TO_SIGN_IN: 'Back to Sign In',
        COMPLETE_PROFILE: 'Complete Profile',
        CONFIRM_PASSWORD: 'Confirm Password',
        DONT_HAVE_ACCOUNT: "Don't have an account?",
        EDIT_PROFILE: 'Edit Profile',
        EMAIL: 'Email',
        EMAIL_VERIFIED_SUCCESSFULLY: '🎉 Email verified successfully!',
        FIRST_NAME: 'First Name',
        FORGOT_PASSWORD: 'Forgot password?',
        LAST_NAME: 'Last Name',
        LOADING: 'Loading ...',
        NEXT: 'Next',
        NEW_PASSWORD: 'New Password',
        OOPS_SOMETHING_WRONG: '❌ Oops, something went wrong, Please try again.',
        OOPS_SOMETHING_WRONG_SUPPORT: '❌ Oops, something went wrong, Please contact support for assistance.',
        OOPS_CHANGE_PASSWORD: "❌ Oops, we couldn't change your password, Please try again.",
        OOPS_FIND_ACCOUNT_EMAIL_PASSWORD: "❌ Oops, we couldn't find an account with that email and password, Please try again.",
        OOPS_FIND_ACCOUNT_EMAIL: "❌ Oops, we couldn't find an account with that email, Please try again.",
        OOPS_ACCOUNT_RECOVERY: "❌ Oops, we couldn't initiate account recovery, Please try again.",
        OOPS_ACCOUNT_RECOVERY_SUPPORT: "❌ Oops, we couldn't initiate account recovery, Please contact support for assistance.",
        OOPS_SAVE_PROFILE: "❌ Oops, we couldn't save your profile, Please try again.",
        OOPS_SET_PASSWORD: "❌ Oops, we couldn't set your password, Please try again.",
        OOPS_SIGN_IN: "❌ Oops, we couldn't sign you in, Please try again.",
        OOPS_SIGN_IN_SUPPORT: "❌ Oops, we couldn't sign you in, Please contact support for assistance.",
        OOPS_RESEND_MAGIC_LINK: "❌ Oops, we couldn't resend a magic link to your email, Please try again.",
        OPTIONAL: 'optional',
        OR: 'OR',
        PASSWORD: 'Password',
        PASSWORD_CANT_CONTAIN_WORD: 'Password cannot contain {word}',
        PLEASE_CHECK_INBOX_INSTRUCTIONS: '🎉 Please check your email inbox for instructions.',
        PASSWORD_AT_LEAST_CHARACTERS: 'Password must be at least {number} characters long.',
        PASSWORD_AT_LEAST_CHARACTER: 'Password must be at least {number} character long.',
        PASSWORD_MUST_CONTAIN_DIGIT: 'Password must contain at least one digit',
        PASSWORD_MUST_CONTAIN_LOWERCASE_LETTER: 'Password must contain at least one lowercase letter',
        PASSWORD_MUST_CONTAIN_UPPERCASE_LETTER: 'Password must contain at least one uppercase letter',
        PASSWORD_MUST_CONTAIN_SPECIAL_CHARACTERS: 'Password must contain at least one special character e.g @,!,&',
        PASSWORD_SET_SUCCESSFULLY: '🎉 Password set successfully! You can now sign into your account.',
        PASSWORD_UPDATED_SUCCESSFULLY: '🎉 Password updated successfully!',
        PHONE_NUMBER: 'Phone number',
        PLEASE_COMPLETE_FIELD: 'Please complete this required field.',
        PLEASE_FIX_ERRORS: '❌ Please fix the errors in the form and try again!',
        PLEASE_ENTER_VALID_EMAIL: 'Please enter a valid email.',
        PLEASE_ENTER_VALID_URL: 'Please enter a valid URL',
        PLEASE_VERIFY_EMAIL: '❌ Please verify your email.<br/> Check your email inbox for instructions.',
        PROFILE_UPDATED_SUCCESSFULLY: '🎉 Profile updated successfully!',
        RECOVER: 'Recover',
        REGISTER: 'Register',
        REQUEST_INVITE: 'Request an invite',
        REQUEST_NEW_MAGIC_LINK: 'Request new magic link',
        RESENDING_MAGIC_LINK: 'Resending a new magic link ...',
        RESET_PASSWORD: 'Reset Password',
        SAVE: 'Save',
        SELECT: 'Select',
        SEND_MAGIC_LINK: 'Send magic link',
        SET_PASSWORD: 'Set Password',
        SIGN_IN: 'Sign in',
        SIGN_IN_TITLE: 'Sign In',
        SIGN_IN_OR_REGISTER: 'Sign In or Register',
        SIGN_IN_WITH: 'Sign in with',
        SIGN_IN_WITH_MAGIC_LINK: 'Sign in with a magic link',
        SIGN_IN_WITH_PROVIDER: 'Sign in with {provider}',
        SIGN_IN_WITH_USERNAME_AND_PASSWORD: 'Sign in with email and password',
        SIGN_OUT: 'Sign Out',
        SIGN_UP: 'Sign up',
        SIGN_UP_WITH: 'Sign up with',
        SIGN_UP_WITH_PROVIDER: 'Sign up with {provider}',
        SIGNED_IN_SUCCESSFULLY: '🎉 Signed in successfully!',
        SORRY_CANT_SIGN_UP: "❌ Sorry, we can't sign you up with email and password at this time.",
        SORRY_CANT_SIGN_UP_SUPPORT: "❌ Sorry, we can't sign you up with email and password at this time. Please contact support for assistance.",
        TELEPHONE: 'Telephone',
        THIS_MORE_CHARACTERS: 'This is more than {number} characters',
        THIS_MORE_CHARACTER: 'This is more than {number} character',
        THIS_MORE_WORDS: 'This is more than {number} words',
        THIS_MORE_WORD: 'This is more than {number} word',
        THIS_LINK_IS_INVALID_EXPIRED_SUPPORT: '❌ This link is either invalid or has expired.<br/> Please contact support for a new link.',
        THIS_LINK_IS_INVALID_EXPIRED_GENERATE: '❌ This link is either invalid or has expired.<br/> Please generate a new recovery link {link_open}here{link_close}.',
        THIS_MAGIC_LINK_INVALID_EXPIRED: '❌ This magic link is either invalid or has expired.',
        VERIFYING: 'Verifying ...',
        YOUR_EMAIL_NOT_VERIFIED_CHECK_INBOX: 'Your email address ({email}) is not verified. Please check your inbox for instructions or {link_open}click here{link_close} to resend the verification email.',
    }

    translations = {
        [this.phrases.ACCOUNT_CREATED_CHECK_INBOX]: {
            [this.languages.SPANISH]: '🎉 ¡La cuenta ha sido creada exitosamente! Por favor, diríjase a su inbox y siga las instrucciones en el mail que le hemos enviado.',
            [this.languages.FRENCH]: '🎉 Le compte a été créé avec succès ! Consultez votre boîte de réception pour obtenir des instructions.',
        },
        [this.phrases.ACCOUNT_EXISTS]: {
            [this.languages.SPANISH]: '❌ Ya existe una cuenta con este correo.',
            [this.languages.FRENCH]: '❌ Un compte avec cette adresse e-mail existe déjà.',
        },
        [this.phrases.ACCOUNT_VERIFICATION_SENT]: {
            [this.languages.SPANISH]: '🎉 Se le ha enviado un correo de verificación a {email} con las instrucciones.',
            [this.languages.FRENCH]: '🎉 Un e-mail de vérification a été envoyé à {email}. Consultez votre boîte de réception pour obtenir des instructions.',
        },
        [this.phrases.ACCOUNT_RECOVERY]: {
            [this.languages.SPANISH]: 'Recuperación de cuenta',
            [this.languages.FRENCH]: 'Récupération du compte',
        },
        [this.phrases.ACCOUNT_VERIFICATION_COMPLETE]: {
            [this.languages.SPANISH]: '🎉 La confirmación de cuenta ha sido completada.',
            [this.languages.FRENCH]: '🎉 La vérification du compte est terminée.',
        },
        [this.phrases.ALREADY_HAVE_ACCOUNT]: {
            [this.languages.SPANISH]: '¿Ya dispone de una cuenta?',
            [this.languages.FRENCH]: 'Vous avez déjà un compte?',
        },
        [this.phrases.BACK_TO_SIGN_IN]: {
            [this.languages.SPANISH]: 'Regresar para iniciar el registro.',
            [this.languages.FRENCH]: 'Retour pour se connecter.',
        },
        [this.phrases.COMPLETE_PROFILE]: {
            [this.languages.SPANISH]: 'Completar su perfil de cuenta.',
            [this.languages.FRENCH]: 'Complètez votre profil.',
        },
        [this.phrases.CONFIRM_PASSWORD]: {
            [this.languages.SPANISH]: 'Confirme su clave.',
            [this.languages.FRENCH]: 'Confirmez votre mot de passe.',
        },
        [this.phrases.DONT_HAVE_ACCOUNT]: {
            [this.languages.SPANISH]: '¿No dispone de una cuenta?',
            [this.languages.FRENCH]: 'Vous n\'avez pas de compte?',
        },
        [this.phrases.EDIT_PROFILE]: {
            [this.languages.SPANISH]: 'Editar perfil',
            [this.languages.FRENCH]: 'Editer votre profil',
        },
        [this.phrases.EMAIL]: {
            [this.languages.SPANISH]: 'Correo',
            [this.languages.FRENCH]: 'E-mail',
        },
        [this.phrases.EMAIL_VERIFIED_SUCCESSFULLY]: {
            [this.languages.SPANISH]: '🎉 ¡El correo ha sido verificado de manera correcta!',
            [this.languages.FRENCH]: '🎉 E-mail vérifié avec succès!',
        },
        [this.phrases.FIRST_NAME]: {
            [this.languages.SPANISH]: 'Nombre',
            [this.languages.FRENCH]: 'Prénom',
        },
        [this.phrases.FORGOT_PASSWORD]: {
            [this.languages.SPANISH]: '¿Ha olvidado su contraseña?',
            [this.languages.FRENCH]: 'Avez-vous oublié votre mot de passe?',
        },
        [this.phrases.LAST_NAME]: {
            [this.languages.SPANISH]: 'Apellido',
            [this.languages.FRENCH]: 'Nom de famille',
        },
        [this.phrases.LOADING]: {
            [this.languages.SPANISH]: 'Cargando ...',
            [this.languages.FRENCH]: 'Chargement ...',
        },
        [this.phrases.NEXT]: {
            [this.languages.SPANISH]: 'Siguiente',
            [this.languages.FRENCH]: 'Prochain',
        },
        [this.phrases.NEW_PASSWORD]: {
            [this.languages.SPANISH]: 'Nueva clave',
            [this.languages.FRENCH]: 'Nouveau mot de passe',
        },
        [this.phrases.OOPS_SOMETHING_WRONG]: {
            [this.languages.SPANISH]: '❌ Algo salió mal. Por favor inténtelo de nuevo.',
            [this.languages.FRENCH]: '❌ Oups, une erreur s\'est produite. Veuillez réessayez.',
        },
        [this.phrases.OOPS_CHANGE_PASSWORD]: {
            [this.languages.SPANISH]: '❌ No pudimos cambiar su contraseña. Por favor intente de nuevo.',
            [this.languages.FRENCH]: '❌ Oups, nous n\'avons pas pu changer votre mot de passe.  Veuillez réessayer.',
        },
        [this.phrases.OOPS_FIND_ACCOUNT_EMAIL_PASSWORD]: {
            [this.languages.SPANISH]: '❌ No pudimos encontrar ninguna cuenta con ese correo o clave. Por favor intente de nuevo.',
            [this.languages.FRENCH]: '❌ Oups, nous n\'avons pas pu trouver de compte avec cette adresse e-mail et ce mot de passe. Veuillez réessayer.',
        },
        [this.phrases.OOPS_FIND_ACCOUNT_EMAIL]: {
            [this.languages.SPANISH]: '❌ No pudimos encontrar ninguna cuenta con ese correo. Por favor intente de nuevo.',
            [this.languages.FRENCH]: '❌ Oups, nous n\'avons pas pu trouver de compte avec cette adresse e-mail. Veuillez réessayer.',
        },
        [this.phrases.OOPS_ACCOUNT_RECOVERY]: {
            [this.languages.SPANISH]: '❌ No pudimos iniciar el proceso de recuperación de cuenta. Por favor intente de nuevo.',
            [this.languages.FRENCH]: '❌ Oups, nous n\'avons pas pu lancer la récupération du compte. Veuillez réessayer.',
        },
        [this.phrases.OOPS_SAVE_PROFILE]: {
            [this.languages.SPANISH]: '❌ No pudimos guardar los cambios de su perfil. Por favor intente de nuevo.',
            [this.languages.FRENCH]: '❌ Oups, nous n\'avons pas pu enregistrer votre profil. Veuillez réessayer.',
        },
        [this.phrases.OOPS_SET_PASSWORD]: {
            [this.languages.SPANISH]: '❌ No pudimos establecer su clave. Por favor intente de nuevo.',
            [this.languages.FRENCH]: '❌ Oups, nous n\'avons pas pu créer votre mot de passe. Veuillez réessayer.',
        },
        [this.phrases.OOPS_SIGN_IN]: {
            [this.languages.SPANISH]: '❌ No pudimos completar el registro. Por favor intente de nuevo.',
            [this.languages.FRENCH]: '❌ Oups, nous n\'avons pas pu vous connecter. Veuillez réessayer.',
        },
        [this.phrases.OOPS_RESEND_MAGIC_LINK]: {
            [this.languages.SPANISH]: '❌ Oops, No fue posible re-enviar el enlace magico a tu correo. Por favor intente de nuevo.',
            [this.languages.FRENCH]: '❌ Oups, nous n\'avons pas pu renvoyer le lien magique a votre e-mail. Veuillez réessayer.',
        },
        [this.phrases.OPTIONAL]: {
            [this.languages.SPANISH]: 'opcional',
            [this.languages.FRENCH]: 'optionnel',
        },
        [this.phrases.OR]: {
            [this.languages.SPANISH]: 'O',
            [this.languages.FRENCH]: 'OU',
        },
        [this.phrases.PASSWORD]: {
            [this.languages.SPANISH]: 'Clave',
            [this.languages.FRENCH]: 'Mot de passe',
        },
        [this.phrases.PASSWORD_CANT_CONTAIN_WORD]: {
            [this.languages.SPANISH]: 'La clave no puede contener {word}',
            [this.languages.FRENCH]: 'Le mot de passe ne peut pas contenir {word}',
        },
        [this.phrases.PLEASE_CHECK_INBOX_INSTRUCTIONS]: {
            [this.languages.SPANISH]: '🎉 Por favor, diríjase a su inbox y siga las instrucciones en el mail que le hemos enviado.',
            [this.languages.FRENCH]: '🎉 Consultez votre boîte de réception pour obtenir des instructions.',
        },
        [this.phrases.PASSWORD_AT_LEAST_CHARACTERS]: {
            [this.languages.SPANISH]: 'La clave debe de tener al menos {number} caracteres de largo.',
            [this.languages.FRENCH]: 'Le mot de passe doit comporter au moins {number} caractères.',
        },
        [this.phrases.PASSWORD_AT_LEAST_CHARACTER]: {
            [this.languages.SPANISH]: 'La clave debe de tener al menos {number} caractere de largo.',
            [this.languages.FRENCH]: 'Le mot de passe doit comporter au moins {number} caractère.',
        },
        [this.phrases.PASSWORD_MUST_CONTAIN_DIGIT]: {
            [this.languages.SPANISH]: 'La clave debe de contener al menos un numero.',
            [this.languages.FRENCH]: 'Le mot de passe doit contenir au moins un chiffre.',
        },
        [this.phrases.PASSWORD_MUST_CONTAIN_LOWERCASE_LETTER]: {
            [this.languages.SPANISH]: 'La clave debe de contener al menos una carácter en minúsculas.',
            [this.languages.FRENCH]: 'Le mot de passe doit contenir au moins une lettre minuscule.',
        },
        [this.phrases.PASSWORD_MUST_CONTAIN_UPPERCASE_LETTER]: {
            [this.languages.SPANISH]: 'La clave debe de contener al menos una carácter en mayúsculas.',
            [this.languages.FRENCH]: 'Le mot de passe doit contenir au moins une lettre majuscule.',
        },
        [this.phrases.PASSWORD_MUST_CONTAIN_SPECIAL_CHARACTERS]: {
            [this.languages.SPANISH]: 'La clave debe al menos contener un carácter especial. Ejemplo: @, !, &.',
            [this.languages.FRENCH]: 'Le mot de passe doit contenir au moins un caractère spécial, par exemple @,!,&',
        },
        [this.phrases.PASSWORD_SET_SUCCESSFULLY]: {
            [this.languages.SPANISH]: '🎉 La clave o contraseña ha sido establecida. Ahora puede iniciar sesion con su cuenta.',
            [this.languages.FRENCH]: '🎉 Mot de passe créé avec succès ! Vous pouvez vous connecter à votre compte.',
        },
        [this.phrases.PASSWORD_UPDATED_SUCCESSFULLY]: {
            [this.languages.SPANISH]: '🎉 ¡La clave o contraseña ha sido actualizada!',
            [this.languages.FRENCH]: '🎉 Le mot de passe a été actualisé avec succès!',
        },
        [this.phrases.PHONE_NUMBER]: {
            [this.languages.SPANISH]: 'Numero de teléfono',
            [this.languages.FRENCH]: 'Numéro de téléphone',
        },
        [this.phrases.PLEASE_COMPLETE_FIELD]: {
            [this.languages.SPANISH]: 'Por favor complete este campo obligatorio.',
            [this.languages.FRENCH]: 'Veuillez completer ce champ obligatoire.',
        },
        [this.phrases.PLEASE_FIX_ERRORS]: {
            [this.languages.SPANISH]: '❌ Por favor corrija los errores en el formulario e intente de nuevo.',
            [this.languages.FRENCH]: '❌ Veuillez corriger les erreurs dans le formulaire et réessayer!',
        },
        [this.phrases.PLEASE_ENTER_VALID_EMAIL]: {
            [this.languages.SPANISH]: 'Por favor inserte un correo valido.',
            [this.languages.FRENCH]: 'Veuillez entrer une adresse email valide.',
        },
        [this.phrases.PLEASE_ENTER_VALID_URL]: {
            [this.languages.SPANISH]: 'Por favor inserte una dirección URL valida.',
            [this.languages.FRENCH]: 'Veuillez entrer une URL valide.',
        },
        [this.phrases.PLEASE_VERIFY_EMAIL]: {
            [this.languages.SPANISH]: '❌ Por favor verifique su correo electrónico.<br/> Revise su cuenta para las instrucciones.',
            [this.languages.FRENCH]: '❌ Veuillez vérifier votre e-mail.<br/> Consultez votre boîte de réception pour obtenir des instructions.',
        },
        [this.phrases.PROFILE_UPDATED_SUCCESSFULLY]: {
            [this.languages.SPANISH]: '🎉 ¡El perfil ha sido actualizado!',
            [this.languages.FRENCH]: '🎉 Le profil a été actualisé avec succès.',
        },
        [this.phrases.RECOVER]: {
            [this.languages.SPANISH]: 'Recuperar',
            [this.languages.FRENCH]: 'Récupérer',
        },
        [this.phrases.REGISTER]: {
            [this.languages.SPANISH]: 'Registrarse',
            [this.languages.FRENCH]: 'S\'inscrire',
        },
        [this.phrases.REQUEST_INVITE]: {
            [this.languages.SPANISH]: 'Pida una invitación',
            [this.languages.FRENCH]: 'Demandez une invitation',
        },
        [this.phrases.REQUEST_NEW_MAGIC_LINK]: {
            [this.languages.SPANISH]: 'Pedir un nuevo enlace magico.',
            [this.languages.FRENCH]: 'Demandez un nouveau lien magique.',
        },
        [this.phrases.RESENDING_MAGIC_LINK]: {
            [this.languages.SPANISH]: 'Reenviando un nuevo enlace magico...',
            [this.languages.FRENCH]: 'Renvoyer un nouveau lien magique...',
        },
        [this.phrases.RESET_PASSWORD]: {
            [this.languages.SPANISH]: 'Restablecer contraseña',
            [this.languages.FRENCH]: 'Réinitialiser le mot de passe',
        },
        [this.phrases.SAVE]: {
            [this.languages.SPANISH]: 'Guardar',
            [this.languages.FRENCH]: 'Sauvegarder',
        },
        [this.phrases.SELECT]: {
            [this.languages.SPANISH]: 'Seleccionar',
            [this.languages.FRENCH]: 'Sélectionner',
        },
        [this.phrases.SEND_MAGIC_LINK]: {
            [this.languages.SPANISH]: 'Mandar enlace mágico',
            [this.languages.FRENCH]: 'Envoyer un lien magique',
        },
        [this.phrases.SET_PASSWORD]: {
            [this.languages.SPANISH]: 'Establecer contraseña',
            [this.languages.FRENCH]: 'Définir le mot de passe',
        },
        [this.phrases.SIGN_IN]: {
            [this.languages.SPANISH]: 'Iniciar sesión',
            [this.languages.FRENCH]: 'Se connecter',
        },
        [this.phrases.SIGN_IN_TITLE]: {
            [this.languages.SPANISH]: 'Iniciar Sesión',
            [this.languages.FRENCH]: 'Se connecter',
        },
        [this.phrases.SIGN_IN_OR_REGISTER]: {
            [this.languages.SPANISH]: 'Iniciar sesión o registrarse',
            [this.languages.FRENCH]: 'Se connecter ou créer un nouveau compte',
        },
        [this.phrases.SIGN_IN_WITH]: {
            [this.languages.SPANISH]: 'Iniciar sesión con',
            [this.languages.FRENCH]: 'Connectez-vous avec',
        },
        [this.phrases.SIGN_IN_WITH_MAGIC_LINK]: {
            [this.languages.SPANISH]: 'Iniciar sesion con enlace magico.',
            [this.languages.FRENCH]: 'Connectez-vous avec un lien magique',
        },
        [this.phrases.SIGN_IN_WITH_PROVIDER]: {
            [this.languages.SPANISH]: 'Iniciar sesión con {provider}',
            [this.languages.FRENCH]: 'Connectez-vous avec {provider}',
        },
        [this.phrases.SIGN_IN_WITH_USERNAME_AND_PASSWORD]: {
            [this.languages.SPANISH]: 'Iniciar sesion con nombre de usuario y contraseña',
            [this.languages.FRENCH]: 'Connectez-vous avec nom d\'utilisateur et mot de passe',
        },
        [this.phrases.SIGN_OUT]: {
            [this.languages.SPANISH]: 'Salir',
            [this.languages.FRENCH]: 'Se déconnecter',
        },
        [this.phrases.SIGN_UP]: {
            [this.languages.SPANISH]: 'Registrarse',
            [this.languages.FRENCH]: 'S\'inscrire',
        },
        [this.phrases.SIGN_UP_WITH]: {
            [this.languages.SPANISH]: 'Registrarse con',
            [this.languages.FRENCH]: 'Inscrivez-vous avec',
        },
        [this.phrases.SIGN_UP_WITH_PROVIDER]: {
            [this.languages.SPANISH]: 'Registrarse con {provider}',
            [this.languages.FRENCH]: 'Inscrivez-vous avec {provider}',
        },
        [this.phrases.SIGNED_IN_SUCCESSFULLY]: {
            [this.languages.SPANISH]: '🎉 ¡Registro completado!',
            [this.languages.FRENCH]: '🎉 Connexion réussie!',
        },
        [this.phrases.SORRY_CANT_SIGN_UP]: {
            [this.languages.SPANISH]: '❌ Lo sentimos, no fue posible hacer el registro de cuenta con este correo y clave.',
            [this.languages.FRENCH]: '❌ Désolé, nous ne pouvons pas vous inscrire avec une adresse e-mail et un mot de passe pour le moment.',
        },
        [this.phrases.TELEPHONE]: {
            [this.languages.SPANISH]: 'Teléfono',
            [this.languages.FRENCH]: 'Téléphone',
        },
        [this.phrases.THIS_MORE_CHARACTERS]: {
            [this.languages.SPANISH]: 'Se ha sobrepasado el limite de {number} caracteres.',
            [this.languages.FRENCH]: 'C\'est plus de {number} caractères',
        },
        [this.phrases.THIS_MORE_CHARACTER]: {
            [this.languages.SPANISH]: 'Se ha sobrepasado el limite de {number} caractere.',
            [this.languages.FRENCH]: 'C\'est plus de {number} caractère',
        },
        [this.phrases.THIS_MORE_WORDS]: {
            [this.languages.SPANISH]: 'Se ha sobrepasado el limite de {number} palabras',
            [this.languages.FRENCH]: 'C\'est plus de {number} mots',
        },
        [this.phrases.THIS_MORE_WORD]: {
            [this.languages.SPANISH]: 'Se ha sobrepasado el limite de {number} palabra',
            [this.languages.FRENCH]: 'C\'est plus de {number} mot',
        },
        [this.phrases.THIS_LINK_IS_INVALID_EXPIRED_SUPPORT]: {
            [this.languages.SPANISH]: '❌ El enlace ha expirado o es inválido.<br/> Por favor contacte al soporte técnico para obtener un nuevo enlace.',
            [this.languages.FRENCH]: '❌ Ce lien est invalide ou a expiré.<br/> Veuillez contacter le support pour un nouveau lien.',
        },
        [this.phrases.THIS_LINK_IS_INVALID_EXPIRED_GENERATE]: {
            [this.languages.SPANISH]: '❌ Este enlace es inválido o ha expirado.<br/> Por favor genere un nuevo enlace de recuperación {link_open}aquí{link_open}.',
            [this.languages.FRENCH]: '❌ Ce lien est invalide ou a expiré.<br/> Veuillez générer un nouveau lien de récupération ici',
        },
        [this.phrases.THIS_MAGIC_LINK_INVALID_EXPIRED]: {
            [this.languages.SPANISH]: '❌ Este enlace magico es invalido o ha expirado.',
            [this.languages.FRENCH]: '❌ Ce lien magique est invalide ou a expiré.',
        },
        [this.phrases.VERIFYING]: {
            [this.languages.SPANISH]: 'Verificando ...',
            [this.languages.FRENCH]: 'Vérification ...',
        },
        [this.phrases.YOUR_EMAIL_NOT_VERIFIED_CHECK_INBOX]: {
            [this.languages.SPANISH]: 'Su correo electrónico ({email}) no ha sido verificado. Por favor revise su cuenta de correo para las seguir las instrucciones o haga {link_open}click aquí{link_close} para reenviar el correo de verificación.',
            [this.languages.FRENCH]: 'Votre adresse e-mail ({email}) n\'est pas vérifiée. Consultez votre boîte de réception pour obtenir des instructions ou {link_open}cliquez ici{link_close} pour renvoyer l\'e-mail de vérification.',
        },
    }

    parseLanguage(lang) {
        const [,parsedLang] = (lang || '').match(/^([A-Za-z]{2})([-_]\w+)*$/i) || [];
        return (parsedLang && Object.keys(this.languages).map(key => this.languages[key]).includes(parsedLang))?parsedLang:null
    }

    detectLanguage() {
        return this.parseLanguage($('html').attr('lang'));
    }

    resolvedLanguage() {
        return (window.booyaConfig && window.booyaConfig.language && this.parseLanguage(window.booyaConfig.language));
    }

    getTranslation(phrase, args=null) {
        const language = this.resolvedLanguage() || this.languages.ENGLISH;
        let translation = this.translations[phrase] && this.translations[phrase][language] || phrase || '';
        if(args && typeof args === 'object') {
            for (let name of Object.keys(args)) {
                translation = translation.replaceAll(`{${name}}`, args[name]);
            }
        }
        return translation;
    }

    getVarTranslation(data, key) {
        const language = this.resolvedLanguage() || this.languages.ENGLISH;
        return data && (
            (data[language] && data[language][key]) ||
            (data[this.languages.ENGLISH] && data[this.languages.ENGLISH][key]) ||
            (data[key])
        ) || '';
    }
}

class BooyaProviders {
    names = {
        GOOGLE: 'google',
        FACEBOOK: 'facebook',
        LINKEDIN: 'linkedin',
        TWITTER: 'twitter',
        GITHUB: 'github',
        EMAIL: 'email',
    };

    translations = new BooyaTranslations();

    map = {
        [this.names.GOOGLE]: { name: 'Google', logo: 'google.svg' },
        [this.names.FACEBOOK]: { name: 'Facebook', logo: 'facebook.svg' },
        [this.names.LINKEDIN]: { name: 'LinkedIn', logo: 'linkedin.svg' },
        [this.names.TWITTER]: { name: 'Twitter', logo: 'twitter.svg' },
        [this.names.GITHUB]: { name: 'Github', logo: 'github.svg' },
        [this.names.EMAIL]: { name: this.translations.getTranslation(this.translations.phrases.EMAIL), logo: 'envelope.svg' },
    };

    getList() {
        return Object.keys(this.map);
    }

    getName(provider) {
        const { name } = this.map[provider] || {};
        return name;
    }

    getLogo(provider) {
        const { logo } = this.map[provider] || {};
        return `https://cdn.jsdelivr.net/npm/@inboundlabs/booya-ui@latest/dist/images/${logo}`;
    }
}

class BooyaWidgets {
    translations = new BooyaTranslations();

    providers = new BooyaProviders();

    selectors = {
        modal: '__booya-modal-overlay',
        modalTop: '__booya-modal-overlay-top',
        modalNoClose: '__booya-modal-overlay-no-close',
        modalAuthWidgets: '__booya-modal-overlay-auth-widgets',
        authWidgetsWrapper: '__booya-auth-widgets-wrapper',
        authWidgetSection: '__booya-auth-widget-section',
        authWidgetSectionSwitch: '__booya-auth-widget-section-switch',
        link: '__booya-link',
        banner: '__booya-banner',
        notice: '__booya-notice',
    };

    banners = {
        INFO: 'info',
        SUCCESS: 'success',
        WARN: 'warn',
        DANGER: 'danger',
    }

    notices = {
        INFO: 'info',
        SUCCESS: 'success',
        WARN: 'warn',
        DANGER: 'danger',
    }

    sections = {
        INVITE: 'invite',
        SIGNIN: 'signin',
        SIGNUP: 'signup',
        RECOVER: 'recover',
        RESET: 'reset',
        MAGIC_LINK: 'magic-link',
    }

    forms = {
        LOGIN: 'login',
        MAGIC_LINK: 'magic_link',
        REGISTER: 'register',
        RECOVER: 'recover',
        RESET: 'reset',
        SET: 'set',
        PROFILE: 'profile',
    };

    formLabels = {
        TITLE: 'title',
        EMAIL: 'email',
        PASSWORD: 'password',
        CONFIRM_PASSWORD: 'confirm_password',
        SUBMIT: 'submit',
        SWITCH_PROMPT: 'switch_prompt',
        SWITCH_CTA: 'switch_cta',
        BACK: 'back',
    };

    getFormLabel(formName, labelName) {
        const formConfig = window.booyaConfig && window.booyaConfig.forms && window.booyaConfig.forms[formName],
            customLabels = formConfig && formConfig.labels;
        return this.translations.getVarTranslation(customLabels, labelName);
    }

    /* Form Widgets */
    renderFormField(input, name, settings) {
        const {
            type :input_type, value, required, placeholder, options, selected,
            label, help_text, character_limit, word_limit, requiredIndicator,
            data :dataAttributes
        } = settings;

        const dataAttributesMarkup = Object.keys(dataAttributes || {}).map(key => `data-${key}="${dataAttributes[key]}"`).join(' ');

        if(input === 'input' && ['checkbox', 'radio'].includes(input_type)) {
            const renderCheckBoxOrRadio = (inputVal, inputLabel) => {
                return `
<fieldset ${required ? `required` : ''} class="${input_type}">
  <input type="${input_type}" name="${name}" value="${inputVal}" ${dataAttributes && dataAttributes.label?'':`data-label="${label || ''}"`} ${dataAttributesMarkup}>
  <span class="checkmark"></span>
  <label>${inputLabel || ''} ${required ? '*' : ''}</label>
</fieldset>
                `;
            };
            if(Array.isArray(options) && options.length) {
                return `
<fieldset>
    <label>${label}</label>
    <div class="choice-options">
    ${options.map(i => renderCheckBoxOrRadio(i.id, i.name)).join('\n')}
    </div>
</fieldset>
`;
            }
            return renderCheckBoxOrRadio(value, label);
        }

        const styleFixer = 'style="width: 100% !important;"';

        let inputHtml = '';
        switch (input) {
            case 'textarea':
                inputHtml = `
<textarea name="${name}"
                  ${required ? `required` : ''}
                  ${character_limit ? `data-character-limit="${character_limit}"` : ''}
                  ${word_limit ? `data-word-limit="${word_limit}"` : ''}
                  ${placeholder ? `placeholder="${placeholder}${(required && !label) && ' *' || ''}"` : ''}
                  ${styleFixer}
                  >${value || ''}</textarea>
            `;
                break;
            case 'input':
            case 'hidden':
                inputHtml = `
<input type="${input_type || 'text'}"
               name="${name}"
               ${required ? `required` : ''}
               ${character_limit ? `data-character-limit="${character_limit}"` : ''}
               ${word_limit ? `data-word-limit="${word_limit}"` : ''}
               ${value ? `value="${value}"` : ''}
               ${placeholder ? `placeholder="${placeholder}${(required && !label && (typeof requiredIndicator !== 'boolean' || requiredIndicator)) && ' *' || ''}"` : ''}
               ${dataAttributesMarkup}
               ${styleFixer}
        >
            `;
                break;
            case 'select':
            case 'multi-select':
                inputHtml = `
<select name="${name}"
        ${input === "multi-select" ? `id="${name}-select"` : ''}
        ${dataAttributesMarkup}
        ${styleFixer}
        >
   <option value="">${placeholder || `- ${this.translations.getTranslation(this.translations.phrases.SELECT)} -`}</option> 
    ${options ? (
        options.map(option => {
                        return `
    <option value="${option.id}"
        ${selected === option.id || value === option.id? `selected` : ''}
        ${input_type === "multi-select" ? `id="${option.name}-${option.id}"` : ''}>
        ${option.name}
    </option>
        `;
                    })) : ''}
</select>
            `;
                break;
            default:
                inputHtml = input;
                break;
        }

        const isHidden = input_type === 'hidden';

        if(isHidden) {
            return inputHtml;
        }

        return `
<fieldset ${required ? `required` : ''}>
    ${label? `
    <label>${label} ${required ? '*' : `
        <span class="optional">(${this.translations.getTranslation(this.translations.phrases.OPTIONAL)})</span>
    `}</label>
    ` : ''}
    
    ${help_text ? `
    <label>
        <legend>${help_text}</legend>
    </label>
    ` : ''}
    
    <div>
        ${inputHtml}
    </div>
</fieldset>
    `;
    }

    renderDivider(label='') {
        return `
<div class="__booya-section-separator">
    <div class="__booya-section-separator-line"></div>
    ${label?`
    <div class="__booya-section-separator-text">${label}</div>
    <div class="__booya-section-separator-line"></div>
    `:''}
</div>
        `;
    }

    renderOAuthButton(provider, options) {
        const { label, redirect_url, error_redirect_url, action = this.translations.getTranslation(this.translations.phrases.SIGN_IN_WITH) } = options || {},
            name = this.providers.getName(provider),
            logo = this.providers.getLogo(provider);

        const nextUrl = (booya && booya.getUrlParameter('next')) || (window.booyaConfig && window.booyaConfig.memberUrl) || location.href || '';
        const guestUrl = (window.booyaConfig && window.booyaConfig.guestUrl) || location.href || '';

        const url = `${(window.booyaConfig && window.booyaConfig.apiRoot) || `https://auth.booya.io${window.booyaConfig && window.booyaConfig.appID?`/${window.booyaConfig.appID}`:''}`}/auth/signin/${provider}/?grant_type=code&redirect_uri=${ redirect_url || nextUrl || '' }&redirect_uri_error=${ error_redirect_url || location.href || guestUrl || '' }`;
        return `
<a href="${provider === this.providers.names.EMAIL?'#':url}" 
   class="__booya-btn __booya-btn-outline __booya-btn-signin __booya-btn-signin-${ provider } ${provider === this.providers.names.EMAIL?'__booya-signin-email-open':''}">
    <img src="${logo}" alt="${ name }"/>${ label || `${action} ${name}` } 
</a>
        `;
    }

    /* Authentication */
    renderAuthFormValidation(error, success, warning) {
        return `
<div class="form-success" style="display: none">
    ${success || ''}
</div>

<div class="form-error" style="display: none" data-error="${error || ''}">
    ${error || ''}
</div>

<div class="form-validation-error" style="display: none">
    ${warning || this.translations.getTranslation(this.translations.phrases.PLEASE_FIX_ERRORS)}
</div>
    `;
    }

    renderAuthForm(type, title, fields, action, options) {
        const {error, success, warning, header, footer, hideAction, repeatValidation = false, target} = options || {};
        const validation = this.renderAuthFormValidation(error, success, warning);
        const cleanedTitle = title?(/^\s?<.*>\s?$/mi.test(title)?title:`<h3>${title}</h3>`):'';

        const markup = `
<form name="${type}" class="__booya-form __booya-${type}-form">
    ${cleanedTitle || ''}
    
    ${header || ''}
    
    ${validation || ''}
    
    ${fields || ''}
    
    ${footer || ''}

    ${repeatValidation && validation || ''}
    
    ${hideAction ? '' : `
    <div class="__booya-form-action">
        <button type="submit" class="__booya-btn">
            ${action}
        </button>
    </div>
    `}
</form>
    `;
        if(target) {
            $(target).html(markup);
            if(window.booya) {
                window.booya.initUI();
            }
            return ;
        }
        return markup;
    }

    /* Verify */
    renderVerifyForm(title, fields, action, options) {
        const {error, success, header, footer, fieldOverrides = {}, ...rest} = options || {};
        return this.renderAuthForm(
            'verify',
            title || `<h3>${this.translations.getTranslation(this.translations.phrases.SIGN_IN_OR_REGISTER)}</h3>`,
            fields || `
        ${this.renderFormField('input', 'email', {
                type: 'email',
                label: this.translations.getTranslation(this.translations.phrases.EMAIL),
                placeholder: this.translations.getTranslation(this.translations.phrases.EMAIL),
                required: true,
                ...(fieldOverrides.email || {}),
            })}
        `,
            action || this.translations.getTranslation(this.translations.phrases.NEXT),
            {
                error: error || this.translations.getTranslation(this.translations.phrases.OOPS_SOMETHING_WRONG),
                success: success || this.translations.getTranslation(this.translations.phrases.EMAIL_VERIFIED_SUCCESSFULLY),
                header,
                footer,
                ...rest
            }
        );
    }

    /* Sign In */
    renderSignInForm(title, fields, action, options) {
        const {error, success, header, footer, fieldOverrides = {}, ...rest} = options || {};
        return this.renderAuthForm(
            'signin',
            title || this.getFormLabel(this.forms.LOGIN, this.formLabels.TITLE) || `<h3>${this.translations.getTranslation(this.translations.phrases.SIGN_IN_TITLE)}</h3>`,
            fields || `
        ${this.renderFormField('input', 'email', {
                type: 'email',
                label: this.getFormLabel(this.forms.LOGIN, this.formLabels.EMAIL) || this.translations.getTranslation(this.translations.phrases.EMAIL),
                placeholder: this.translations.getTranslation(this.translations.phrases.EMAIL),
                required: true,
                ...(fieldOverrides.email || {}),
            })}
        ${this.renderFormField('input', 'password', {
                type: 'password',
                label: this.getFormLabel(this.forms.LOGIN, this.formLabels.PASSWORD) ||  this.translations.getTranslation(this.translations.phrases.PASSWORD),
                placeholder: this.translations.getTranslation(this.translations.phrases.PASSWORD),
                required: true,
                ...(fieldOverrides.password || {}),
            })}
        `,
            action || this.getFormLabel(this.forms.LOGIN, this.formLabels.SUBMIT) ||  this.translations.getTranslation(this.translations.phrases.SIGN_IN_TITLE),
            {
                error: error || this.translations.getTranslation(this.translations.phrases.OOPS_SIGN_IN),
                success: success || this.translations.getTranslation(this.translations.phrases.SIGNED_IN_SUCCESSFULLY),
                header,
                footer,
                ...rest
            }
        );
    }

    /* Sign Up */
    renderSignUpForm(title, fields, action, options) {
        const {error, success, header, footer, includeTel = false, includeLabels = true, repeatValidation = true, fieldOverrides = {}, ...rest} = options || {};

        const hsForm = window.booyaConfig && window.booyaConfig.forms && window.booyaConfig.forms.registration;
        let hsFormMarkup = '',
            hsAction = '';
        if(hsForm) {
            hsFormMarkup = ([...(hsForm.fields || []), ...(hsForm.consentFields || [])]).map(field => {
                if(field.html) {
                    return field.html;
                }
                if(field.name) {
                    const { input, name, ...fieldSettings} = field;
                    return this.renderFormField(input, name, {
                        ...(fieldSettings || {}),
                        label: fieldSettings && fieldSettings.label && this.translations.getTranslation(fieldSettings.label) || '',
                        placeholder: fieldSettings && fieldSettings.placeholder && this.translations.getTranslation(fieldSettings.placeholder) || '',
                    });
                }
                return '';
            }).join('').trim();
            hsAction = hsForm.submitText || '';
        }

        return this.renderAuthForm(
            'signup',
            title || this.getFormLabel(this.forms.REGISTER, this.formLabels.TITLE) || `<h3>${this.translations.getTranslation(this.translations.phrases.REGISTER)}</h3>`,
            fields || hsFormMarkup || `
        ${this.renderFormField('input', 'email', {
                type: 'email',
                label: includeLabels && this.translations.getTranslation(this.translations.phrases.EMAIL) || '',
                placeholder: this.translations.getTranslation(this.translations.phrases.EMAIL),
                required: true,
                ...(fieldOverrides.email || {}),
            })}
        ${this.renderFormField('input', 'password', {
                type: 'password',
                label: includeLabels && this.translations.getTranslation(this.translations.phrases.PASSWORD) || '',
                placeholder: this.translations.getTranslation(this.translations.phrases.PASSWORD),
                required: true,
                ...(fieldOverrides.password || {}),
            })}
        ${this.renderFormField('input', 'first_name', {
                type: 'text',
                label: includeLabels && this.translations.getTranslation(this.translations.phrases.FIRST_NAME) || '',
                placeholder: this.translations.getTranslation(this.translations.phrases.FIRST_NAME),
                required: true,
                ...(fieldOverrides.first_name || {}),
            })}
        ${this.renderFormField('input', 'last_name', {
                type: 'text',
                label: includeLabels && this.translations.getTranslation(this.translations.phrases.LAST_NAME) || '',
                placeholder: this.translations.getTranslation(this.translations.phrases.LAST_NAME),
                required: true,
                ...(fieldOverrides.last_name || {}),
            })}
        ${includeTel ? this.renderFormField('input', 'telephone', {
                type: 'tel',
                label: includeLabels && this.translations.getTranslation(this.translations.phrases.PHONE_NUMBER) || '',
                placeholder: this.translations.getTranslation(this.translations.phrases.PHONE_NUMBER),
                required: false,
                ...(fieldOverrides.telephone || {}),
            }): ''}
        `,
            action || hsAction || this.translations.getTranslation(this.translations.phrases.REGISTER),
            {
                error: error || this.translations.getTranslation(this.translations.phrases.SORRY_CANT_SIGN_UP),
                success: success || this.translations.getTranslation(this.translations.phrases.ACCOUNT_CREATED_CHECK_INBOX),
                header,
                footer,
                repeatValidation,
                ...rest
            }
        );
    }

    /* Complete Profile */
    renderProfileForm(title, fields, action, options) {
        const {error, success, header, footer, includeTel = true, repeatValidation = false, fieldOverrides = {}, ...rest} = options || {};
        const user = window.user || {};

        const hsForm = window.booyaConfig && window.booyaConfig.forms && window.booyaConfig.forms.profile;
        let hsFormMarkup = '',
            hsAction = '';
        if(hsForm) {
            hsFormMarkup = ([...(hsForm.fields || []), ...(hsForm.consentFields || [])]).map(field => {
                if(field.html) {
                    return field.html;
                }
                if(field.name) {
                    const { input, name, ...fieldSettings} = field;
                    return this.renderFormField(input, name, {
                        ...(fieldSettings || {}),
                        label: fieldSettings && fieldSettings.label && this.translations.getTranslation(fieldSettings.label) || '',
                        placeholder: fieldSettings && fieldSettings.placeholder && this.translations.getTranslation(fieldSettings.placeholder) || '',
                        ...(user[name]?{value: user[name] || ''}:{}),
                    });
                }
                return '';
            }).join('').trim();
            hsAction = hsForm.submitText;
        }

        return this.renderAuthForm(
            'profile',
            title || this.getFormLabel(this.forms.PROFILE, this.formLabels.TITLE) || `<h3>${this.translations.getTranslation(this.translations.phrases.COMPLETE_PROFILE)}</h3>`,
            fields || hsFormMarkup || `
        ${this.renderFormField('input', 'first_name', {
                type: 'text',
                label: this.translations.getTranslation(this.translations.phrases.FIRST_NAME),
                placeholder: this.translations.getTranslation(this.translations.phrases.FIRST_NAME),
                required: true,
                value: user.first_name || '',
                ...(fieldOverrides.first_name || {}),
            })}
        ${this.renderFormField('input', 'last_name', {
                type: 'text',
                label: this.translations.getTranslation(this.translations.phrases.LAST_NAME),
                placeholder: this.translations.getTranslation(this.translations.phrases.LAST_NAME),
                required: true,
                value: user.last_name || '',
                ...(fieldOverrides.last_name || {}),
            })}
        ${includeTel ? this.renderFormField('input', 'telephone', {
                type: 'tel',
                label: this.translations.getTranslation(this.translations.phrases.PHONE_NUMBER),
                placeholder: this.translations.getTranslation(this.translations.phrases.PHONE_NUMBER),
                required: false,
                value: user.telephone || '',
            }) : ''}
        `,
            action || hsAction || this.translations.getTranslation(this.translations.phrases.SAVE),
            {
                error: error || this.translations.getTranslation(this.translations.phrases.OOPS_SAVE_PROFILE),
                success: success || this.translations.getTranslation(this.translations.phrases.PROFILE_UPDATED_SUCCESSFULLY),
                header,
                footer,
                repeatValidation,
                ...rest
            }
        );
    }

    /* Magic Link */
    renderMagicLinkForm(title, fields, action, options) {
        const {error, success, header, footer, fieldOverrides = {}, ...rest} = options || {};
        return this.renderAuthForm(
            'magic-link',
            title || this.getFormLabel(this.forms.MAGIC_LINK, this.formLabels.TITLE) || `<h3>${this.translations.getTranslation(this.translations.phrases.SIGN_IN_TITLE)}</h3>`,
            fields || `
        ${this.renderFormField('input', 'email', {
                type: 'email',
                label: this.getFormLabel(this.forms.MAGIC_LINK, this.formLabels.EMAIL) || this.translations.getTranslation(this.translations.phrases.EMAIL),
                placeholder: this.translations.getTranslation(this.translations.phrases.EMAIL),
                required: true,
                ...(fieldOverrides.email || {}),
            })}
        `,
            action || this.getFormLabel(this.forms.MAGIC_LINK, this.formLabels.SUBMIT) || this.translations.getTranslation(this.translations.phrases.SEND_MAGIC_LINK),
            {
                error: error || this.translations.getTranslation(this.translations.phrases.OOPS_FIND_ACCOUNT_EMAIL),
                success: success || this.translations.getTranslation(this.translations.phrases.PLEASE_CHECK_INBOX_INSTRUCTIONS),
                header,
                footer,
                ...rest
            }
        );
    }

    /* Recover Account */
    renderRecoverForm(title, fields, action, options) {
        const {error, success, header, footer, fieldOverrides = {}, ...rest} = options || {};
        return this.renderAuthForm(
            'recover-account',
            title || this.getFormLabel(this.forms.RECOVER, this.formLabels.TITLE) || `<h3>${this.translations.getTranslation(this.translations.phrases.ACCOUNT_RECOVERY)}</h3>`,
            fields || `
        ${this.renderFormField('input', 'email', {
                type: 'email',
                label: this.getFormLabel(this.forms.RECOVER, this.formLabels.EMAIL) || this.translations.getTranslation(this.translations.phrases.EMAIL),
                placeholder: this.translations.getTranslation(this.translations.phrases.EMAIL),
                required: true,
                ...(fieldOverrides.email || {}),
            })}
        `,
            action || this.getFormLabel(this.forms.RECOVER, this.formLabels.SUBMIT) || this.translations.getTranslation(this.translations.phrases.RECOVER),
            {
                error: error || this.translations.getTranslation(this.translations.phrases.OOPS_ACCOUNT_RECOVERY),
                success: success || this.translations.getTranslation(this.translations.phrases.PLEASE_CHECK_INBOX_INSTRUCTIONS),
                header,
                footer,
                ...rest
            }
        );
    }

    /* Set Password */
    renderSetPasswordForm(title, fields, action, options) {
        const {error, success, header, footer, fieldOverrides = {}, ...rest} = options || {};
        return this.renderAuthForm(
            'set-password',
            title || this.getFormLabel(this.forms.SET, this.formLabels.TITLE) || `<h3>${this.translations.getTranslation(this.translations.phrases.SET_PASSWORD)}</h3>`,
            fields || `
        ${this.renderFormField('input', 'new_password', {
                type: 'password',
                label: this.getFormLabel(this.forms.SET, this.formLabels.PASSWORD) || this.translations.getTranslation(this.translations.phrases.PASSWORD),
                placeholder: this.translations.getTranslation(this.translations.phrases.PASSWORD),
                required: true,
                ...(fieldOverrides.new_password || {}),
            })}
        ${this.renderFormField('input', 'confirm_password', {
                type: 'password',
                label: this.getFormLabel(this.forms.SET, this.formLabels.CONFIRM_PASSWORD) || this.translations.getTranslation(this.translations.phrases.CONFIRM_PASSWORD),
                placeholder: this.translations.getTranslation(this.translations.phrases.CONFIRM_PASSWORD),
                required: true,
                ...(fieldOverrides.confirm_password || {}),
            })}
        `,
            action || this.getFormLabel(this.forms.SET, this.formLabels.SUBMIT) || this.translations.getTranslation(this.translations.phrases.SAVE),
            {
                error: error || this.translations.getTranslation(this.translations.phrases.OOPS_SET_PASSWORD),
                success: success || this.translations.getTranslation(this.translations.phrases.PASSWORD_SET_SUCCESSFULLY),
                header,
                footer,
                ...rest
            }
        );
    }

    /* Reset Password */
    renderResetForm(title, fields, action, options) {
        const {error, success, header, footer, fieldOverrides = {}, ...rest} = options || {};
        return this.renderAuthForm(
            'reset-password',
            title || this.getFormLabel(this.forms.RESET, this.formLabels.TITLE) || `<h3>${this.translations.getTranslation(this.translations.phrases.RESET_PASSWORD)}</h3>`,
            fields || `
        ${this.renderFormField('input', 'new_password', {
                type: 'password',
                label: this.getFormLabel(this.forms.RESET, this.formLabels.PASSWORD) || this.translations.getTranslation(this.translations.phrases.NEW_PASSWORD),
                placeholder: this.translations.getTranslation(this.translations.phrases.NEW_PASSWORD),
                required: true,
                ...(fieldOverrides.new_password || {}),
            })}
        ${this.renderFormField('input', 'confirm_password', {
                type: 'password',
                label: this.getFormLabel(this.forms.RESET, this.formLabels.CONFIRM_PASSWORD) || this.translations.getTranslation(this.translations.phrases.CONFIRM_PASSWORD),
                placeholder: this.translations.getTranslation(this.translations.phrases.CONFIRM_PASSWORD),
                required: true,
                ...(fieldOverrides.confirm_password || {}),
            })}
        `,
            action || this.getFormLabel(this.forms.RESET, this.formLabels.SUBMIT) || this.translations.getTranslation(this.translations.phrases.SAVE),
            {
                error: error || this.translations.getTranslation(this.translations.phrases.OOPS_CHANGE_PASSWORD),
                success: success || this.translations.getTranslation(this.translations.phrases.PASSWORD_UPDATED_SUCCESSFULLY),
                header,
                footer,
                ...rest
            }
        );
    }

    /* Modals */
    renderModal(title, content, options) {
        const { className, target, isOpen=false, canClose=true, isTop=false } = options || {};
        const markup = `
<div class="${this.selectors.modal} ${!canClose && this.selectors.modalNoClose || ''} ${isTop && this.selectors.modalTop || ''} ${className || ''}" style="display: ${isOpen?'block':'none'}">
  <div class="__booya-modal">
    <div class="__booya-modal-header">
      ${title || ''}
      
      ${canClose && `
      <div class="__booya-close">
        <svg viewBox="0 0 14 14" xmlns="http://www.w3.org/2000/svg">
          <path d="M14.5,1.5l-13,13m0-13,13,13" transform="translate(-1 -1)"></path>
        </svg>
      </div>
      ` || ''}
    </div>
    <div class="__booya-modal-content">
        ${content || ''}
    </div>
  </div>
</div>
    `;
        if(target || isOpen) {
            if(target) {
                $(target).html(markup);
            } else {
                $('body').append(markup);
            }
            if(window.booya) {
                window.booya.initUI();
            }
            return ;
        }
        return markup;
    }

    closeModal(child=null) {
        const closableModalSelector = `.${this.selectors.modal}:not(.${this.selectors.modalNoClose})`;
        let modal = child?$(child).closest(closableModalSelector):$(`.${this.selectors.modal}`);
        modal.hide();
    }

    /* Alias for closeModal for legacy support */
    removeModal(child=null) {
        this.closeModal(child);
    }

    /* Complete Auth Widgets */
    renderAuthWidgets(options) {
        let { header, footer, signIn=true, signUp=true, recover=true, verify=false, multiStep=false, magicLink=false, switches=null, target=null, className='', modal=null, section :originalSection=null } = options || {};
        const onlyMagicLink = (booyaConfig && booyaConfig.magicLink && booyaConfig.magicLink.only) || (booyaConfig && booyaConfig.onlyMagicLink) || false;
        const magicLinkEnabled = onlyMagicLink || (booyaConfig && booyaConfig.magicLink && booyaConfig.magicLink.enabled) || false;

        if(magicLinkEnabled) {
            // Enable magic link
            magicLink = true;

            if(onlyMagicLink) {
                // Disable everything else
                signIn = false;
                signUp = false;
                recover = false;
                verify = false;
                multiStep = false;

                // ignore section
                originalSection = null;
            }
        }

        const { form :signInForm, args: signInFormArguments, oauth :oauthSection, footer :signInFooter, switch :signInSwitch } = typeof signIn === 'object' && signIn || {};
        const { form :signUpForm, args: signUpFormArguments, footer :signUpFooter, switch :signUpSwitch } = typeof signUp === 'object' && signUp || {};
        const { form :recoverForm, args: recoverFormArguments, footer :recoverFooter, switch :recoverSwitch } = typeof recover === 'object' && recover || {};
        const { form :verifyForm, args: verifyFormArguments } = (typeof multiStep === 'object' && multiStep) || (typeof verify === 'object' && verify) || {};
        const { form :magicLinkForm, args: magicLinkFormArguments, footer :magicLinkFooter, switch :magicLinkSwitch } = typeof magicLink === 'object' && magicLink || {};
        const { signIn :signInSwitchLegacy, signUp :signUpSwitchLegacy, recover :recoverSwitchLegacy, magicLink :magicLinkSwitchLegacy } = switches || {};
        const { info :signInSwitchInfo, cta :signInSwitchCTA, back :signInSwitchBack } = signInSwitch || signInSwitchLegacy || {};
        const { info :signUpSwitchInfo, cta :signUpSwitchCTA } = signUpSwitch || signUpSwitchLegacy || {};
        const { info :recoverSwitchInfo, cta :recoverSwitchCTA } = recoverSwitch || recoverSwitchLegacy || {};
        const { info :magicLinkSwitchInfo, cta :magicLinkSwitchCTA } = magicLinkSwitch || magicLinkSwitchLegacy || {};

        let oauthProviders = [];
        if(window.booyaConfig && Array.isArray(window.booyaConfig.providers)) {
            oauthProviders = window.booyaConfig.providers.filter(provider => provider !== this.providers.names.EMAIL);
        }

        let reactiveSignUpFormArguments = null;
        if(oauthProviders.length) {
            const [signUpTitle, signUpFields, signUpAction, signUpOptions] = signUpFormArguments || [];
            reactiveSignUpFormArguments = [
                signUpTitle, signUpFields, signUpAction, {
                    ...(signUpOptions || {}),
                    ...(signUpOptions && typeof signUpOptions.includeLabels === 'boolean'?{includeLabels: signUpOptions.includeLabels}:{}),
                    ...(signUpOptions && typeof signUpOptions.repeatValidation === 'boolean'?{repeatValidation: signUpOptions.repeatValidation}:{}),
                }
            ]
        }

        const inviteRequired = booyaConfig && booyaConfig.invite && booyaConfig.invite.required || false,
            inviteRequestUrl = booyaConfig && booyaConfig.invite && booyaConfig.invite.requestUrl || '';

        let section = originalSection;
        if(!section) {
            section = (signIn && this.sections.SIGNIN) || (magicLink && this.sections.MAGIC_LINK) || (!inviteRequired && signUp && this.sections.SIGNUP);
        }

        const signUpSwitchMarkup = signUp && `<div class="${this.selectors.authWidgetSectionSwitch}-wrapper ${this.selectors.authWidgetSectionSwitch}-wrapper-${this.sections.SIGNUP}">
                    ${signUpSwitchInfo || this.getFormLabel(this.forms.REGISTER, this.formLabels.SWITCH_PROMPT) || this.translations.getTranslation(this.translations.phrases.DONT_HAVE_ACCOUNT)} <a href="#" class="${this.selectors.link} ${this.selectors.authWidgetSectionSwitch}-${this.sections.SIGNUP}">${signUpSwitchCTA || this.getFormLabel(this.forms.REGISTER, this.formLabels.SWITCH_CTA) || this.translations.getTranslation(this.translations.phrases.SIGN_UP)}</a>
                </div>` || '';
        const signInMarkup = signIn && `<div class="${this.selectors.authWidgetSection} ${this.selectors.authWidgetSection}-${this.sections.SIGNIN}" ${section && section !== this.sections.SIGNIN?'style="display: none"':''}>
        ${signInForm || this.renderSignInForm(...(signInFormArguments || []))}
        ${oauthSection || (
            oauthProviders.length && `
                ${this.renderDivider(this.translations.getTranslation(this.translations.phrases.OR))}
                ${oauthProviders.map(provider => this.renderOAuthButton(provider)).join('')}
        ` || '')}
        ${signInFooter || `
            ${magicLink && `
            <div class="${this.selectors.authWidgetSectionSwitch}-wrapper ${this.selectors.authWidgetSectionSwitch}-wrapper-${this.sections.MAGIC_LINK}">
            ${magicLinkSwitchInfo || this.getFormLabel(this.forms.MAGIC_LINK, this.formLabels.SWITCH_PROMPT) || ''}<a href="#" class="${this.selectors.link} ${this.selectors.authWidgetSectionSwitch}-${this.sections.MAGIC_LINK}">${magicLinkSwitchCTA || this.getFormLabel(this.forms.MAGIC_LINK, this.formLabels.SWITCH_CTA) || this.translations.getTranslation(this.translations.phrases.SIGN_IN_WITH_MAGIC_LINK)}</a>
            </div>
            ` || ''}
            
            ${recover && `
            <div class="${this.selectors.authWidgetSectionSwitch}-wrapper ${this.selectors.authWidgetSectionSwitch}-wrapper-${this.sections.RECOVER}">
            ${recoverSwitchInfo || this.getFormLabel(this.forms.RECOVER, this.formLabels.SWITCH_PROMPT) || ''}<a href="#" class="${this.selectors.link} ${this.selectors.authWidgetSectionSwitch}-${this.sections.RECOVER}">${recoverSwitchCTA || this.getFormLabel(this.forms.RECOVER, this.formLabels.SWITCH_CTA) || this.translations.getTranslation(this.translations.phrases.FORGOT_PASSWORD)}</a>
            </div>
            ` || ''}
            
            ${!multiStep && `
                ${((!inviteRequired && signUp) || (inviteRequired && inviteRequestUrl)) && this.renderDivider() || ''}
                
                ${inviteRequired?(inviteRequestUrl && `
                <div class="${this.selectors.authWidgetSectionSwitch}-wrapper ${this.selectors.authWidgetSectionSwitch}-wrapper-${this.sections.INVITE}">
                    ${signUpSwitchInfo || this.getFormLabel(this.forms.REGISTER, this.formLabels.SWITCH_PROMPT) || this.translations.getTranslation(this.translations.phrases.DONT_HAVE_ACCOUNT)} <a href="${inviteRequestUrl}" class="${this.selectors.link}">${signUpSwitchCTA || this.translations.getTranslation(this.translations.phrases.REQUEST_INVITE)}</a>
                </div>
                ` || ''):signUpSwitchMarkup}
            ` || ''}
        ` || ''}
    </div>` || ''; // TODO: Add custom switch prompts and ctas for invites
        const signUpMarkup = !inviteRequired && signUp && `
    <div class="${this.selectors.authWidgetSection} ${this.selectors.authWidgetSection}-${this.sections.SIGNUP}" ${section !== this.sections.SIGNUP?'style="display: none"':''}>
        ${signUpForm || this.renderSignUpForm(...(reactiveSignUpFormArguments || signUpFormArguments || []))}
        ${oauthSection || (
            oauthProviders.length && `
                ${this.renderDivider(this.translations.getTranslation(this.translations.phrases.OR))}
                ${oauthProviders.map(provider => this.renderOAuthButton(provider, { action: this.translations.getTranslation(this.translations.phrases.SIGN_UP_WITH) })).join('')}
        ` || '')}
        ${multiStep?'':(signUpFooter || ((magicLink || signIn) && `
            <div class="${this.selectors.authWidgetSectionSwitch}-wrapper ${this.selectors.authWidgetSectionSwitch}-wrapper-${magicLink?this.sections.MAGIC_LINK:this.sections.SIGNIN}">
            ${(magicLink && (magicLinkSwitchInfo || this.getFormLabel(this.forms.MAGIC_LINK, this.formLabels.SWITCH_PROMPT))) || signInSwitchInfo || this.getFormLabel(this.forms.LOGIN, this.formLabels.SWITCH_PROMPT) || this.translations.getTranslation(this.translations.phrases.ALREADY_HAVE_ACCOUNT)} <a href="#" class="${this.selectors.link} ${this.selectors.authWidgetSectionSwitch}-${magicLink?this.sections.MAGIC_LINK:this.sections.SIGNIN}">${(magicLink && (magicLinkSwitchCTA || this.getFormLabel(this.forms.MAGIC_LINK, this.formLabels.SWITCH_CTA))) || signInSwitchCTA || this.getFormLabel(this.forms.LOGIN, this.formLabels.SWITCH_CTA) || this.translations.getTranslation(this.translations.phrases.SIGN_IN)}</a>
            </div>
        ` || ''))}
    </div>
    ` || '';
        const recoverMarkup = recover && `<div class="${this.selectors.authWidgetSection} ${this.selectors.authWidgetSection}-${this.sections.RECOVER}" ${section !== this.sections.RECOVER?'style="display: none"':''}>
        ${recoverForm || this.renderRecoverForm(...(recoverFormArguments || []))}
        ${recoverFooter || (signIn && `
            <div class="${this.selectors.authWidgetSectionSwitch}-wrapper ${this.selectors.authWidgetSectionSwitch}-wrapper-${this.sections.SIGNIN}">
            <a href="#" class="${this.selectors.link} ${this.selectors.authWidgetSectionSwitch}-${this.sections.SIGNIN}">${signInSwitchBack || this.getFormLabel(this.forms.LOGIN, this.formLabels.BACK) || this.translations.getTranslation(this.translations.phrases.BACK_TO_SIGN_IN)}</a>
            </div>
        `)} 
    </div>` || '';
        const verifyMarkup = verifyForm || this.renderVerifyForm(...(verifyFormArguments || []));
        const magicLinkMarkup = magicLink && `<div class="${this.selectors.authWidgetSection} ${this.selectors.authWidgetSection}-${this.sections.MAGIC_LINK}" ${section && section !== this.sections.MAGIC_LINK?'style="display: none"':''}>
        ${magicLinkForm || this.renderMagicLinkForm(...(magicLinkFormArguments || []))}
        ${oauthSection || (
            oauthProviders.length && `
                ${this.renderDivider(this.translations.getTranslation(this.translations.phrases.OR))}
                ${oauthProviders.map(provider => this.renderOAuthButton(provider)).join('')}
        ` || '')}
        ${onlyMagicLink?'':(magicLinkFooter || `
            <div class="${this.selectors.authWidgetSectionSwitch}-wrapper ${this.selectors.authWidgetSectionSwitch}-wrapper-${this.sections.SIGNIN}">
            ${signInSwitchInfo || ''}<a href="#" class="${this.selectors.link} ${this.selectors.authWidgetSectionSwitch}-${this.sections.SIGNIN}">${signInSwitchCTA || this.getFormLabel(this.forms.LOGIN, this.formLabels.SWITCH_CTA) || this.translations.getTranslation(this.translations.phrases.SIGN_IN_WITH_USERNAME_AND_PASSWORD)}</a>
            </div>
            ${signUpSwitchMarkup}
        `)}
    </div>` || '';

        let markup = `
    <div class="${this.selectors.authWidgetsWrapper}${className?` ${className}`:''}">
        ${header || ''}
        ${multiStep && verifyMarkup || `
            ${signInMarkup || ''}
            ${signUpMarkup || ''}
            ${recoverMarkup || ''}
            ${magicLinkMarkup || ''}
        `}
        ${footer || ''}
    </div>`;

        if(multiStep) {
            // Setup multi step events
            booya.on(booya.events.VERIFY_EMAIL_SUCCESS, e => {
                const email = e.email || '';
                booya.widgets.renderModal(
                    '',
                    `${signInMarkup}${recoverMarkup}${magicLinkMarkup}`,
                    { isOpen: true },
                );

                const signInWrapper = $(`.${this.selectors.authWidgetSection}-${this.sections.SIGNIN}`);
                signInWrapper.show();
                const signInEmailWrapper = signInWrapper.find('[type="email"]');
                signInEmailWrapper.val(email);
                signInEmailWrapper.closest('fieldset').hide();
                $(`.${this.selectors.authWidgetSection}-${this.sections.RECOVER} [type="email"]`).val(email);
            });

            booya.on(booya.events.VERIFY_EMAIL_FAILED, e => {
                const email = e.email || '';
                booya.widgets.renderModal(
                    '',
                    `${signUpMarkup}`,
                    { isOpen: true },
                );
                const signUpWrapper = $(`.${this.selectors.authWidgetSection}-${this.sections.SIGNUP}`);
                signUpWrapper.show();

                const signUpEmailWrapper = signUpWrapper.find(`[type="email"]`);
                signUpEmailWrapper.val(email);
                signUpEmailWrapper.closest('fieldset').hide();
            });
        }

        if(modal) {
            const { title, className :modalClassName, isOpen=false, ...otherOptions } = modal || {};
            markup = this.renderModal(
                title, markup, {
                    ...otherOptions,
                    className: `${this.selectors.modalAuthWidgets}${modalClassName?` ${modalClassName}`:''}`,
                    isOpen
                });
        }

        if(target) {
            $(target).html(markup);
            if(window.booya) {
                window.booya.initUI();
            }
            return;
        }
        return markup;
    }

    openAuthWidget(widget) {
        $(`.${this.selectors.authWidgetSection}`).hide();
        $(`.${this.selectors.authWidgetSection}-${widget}`).show();
    }

    renderUserWidget(target, options) {
        const user = window.user,
            self = this;
        if(!user || !target || $(target).find('.__booya-user-widget').length) return null;

        const markup =  `
<div class="__booya-user-widget">
    <div>
        <img src="${user.avatar}"/> <span class="__booya-user-name">${`${user.first_name} ${user.last_name}`.trim() || user.email.replace(/@.*/i, '')}</span>
    </div>
    <div class="__booya-user-widget-options">
        <div class="__booya-user-widget-option __booya-edit-profile">${this.translations.getTranslation(this.translations.phrases.EDIT_PROFILE)}</div>
        <div class="__booya-user-widget-option __booya-logout">${this.translations.getTranslation(this.translations.phrases.SIGN_OUT)}</div>
    </div>
</div>
        `;
        $(target).append(markup);
        const userWidget = $('.__booya-user-widget');

        const { profile :onEditProfile, logout :logOut } = options || {};

        userWidget.find('.__booya-edit-profile').off('click').click(function () {
            // Edit Profile
            if(onEditProfile) {
                onEditProfile();
            } else {
                booya.trigger(booya.events.EDIT_PROFILE_PROMPT);

                if(!booya.isEventOverridden(booya.events.EDIT_PROFILE_PROMPT)) {
                    self.renderModal(
                        '',
                        self.renderProfileForm(`<h3>${self.translations.getTranslation(self.translations.phrases.EDIT_PROFILE)}</h3>`),
                        {
                            isOpen: true,
                        },
                    )
                }
            }
        });

        userWidget.find('.__booya-logout').off('click').click(function () {
            // Logout
            if(logOut) {
                logOut();
            } else {
                booya.logOut();
            }
        });
    }

    renderNotice(content, appearance='info', className='') {
        return `
<div class="${this.selectors.notice}${appearance?` ${this.selectors.notice}-${appearance|| 'info'}`:''}${className?` ${className}`:''}">
    ${content}
</div>
        `;
    }

    renderBanner(content, appearance='info', isOpen=true, className='') {
        const markup = `
<div class="${this.selectors.banner}${appearance?` ${this.selectors.banner}-${appearance|| 'info'}`:''}${className?` ${className}`:''}">
    <div class="__booya-banner-content">
        <div class="__booya-banner-message">${content}</div>
        <div class="__booya-banner-close">
            <img src="https://cdn.jsdelivr.net/npm/@inboundlabs/booya-ui@latest/dist/images/close-white.svg" width="16px" />
        </div>
    </div>
</div>
        `;
        if(isOpen) {
            $('body').append(markup);
            if(window.booya) {
                window.booya.initUI();
            }
        }
        return markup;
    }

    renderTimedBanner(content, appearance='info', delay=3000) {
        const className = `${this.selectors.banner}-${Date.now()}`;
        this.renderBanner(content, appearance, true, className);
        setTimeout(() => {
            $(`.${className}`).remove();
        }, delay || 3000);
    }

    renderAccountVerifiedBanner(content) {
        return this.renderBanner(
            content || '🎉 Account verification complete.', this.banners.SUCCESS, true
        );
    }
}

class Booya {

    constructor() {
        // Update window reference
        window.booya = this;

        this.isInitialized = false;
        this.isReady = false;

        // For GDPR compliance, delete legacy booyaHubspotutk cookie if it exists
        if(this.getCookie('booyaHubspotutk')) {
            this.deleteCookie('booyaHubspotutk');
        }

        // Backwards compatibility
        this.submitHubSpotVerificationForm = this.identifyHubSpotUser;

        const hasBrixModules = $('#brix-booya-signin').length || $('#brix-booya-user-widget').length || $('.brix-dashboard-object-wrapper').length;
        if(window.booyaConfig.__product !== 'brix' && hasBrixModules) {
            window.booyaConfig.__product = 'brix';
            window.booyaConfig.__platform = 'hubspot';
        }

        this.setConfig({
            portalID: '',
            appID: '',
            memberUrl: '',
            guestUrl: '',
            recoverUrl: '',
            resetUrl: '',
            __mode: 'live',
            ...(window.booyaConfig || {}),
            language: (window.booyaConfig && window.booyaConfig.language) || this.translations.detectLanguage() || this.translations.languages.ENGLISH,
        });

        const self = this;

        function completeInitialization() {
            const isBrix = self.config.__product === 'brix';

            const initEditorBannerLinks = () => {
                if(window.hsInEditor) {
                    $('.__booya-banner a').off('click').click(e => {
                        const url = e.target.href;
                        if(url) {
                            e.preventDefault();
                            window.open(e.target.href, '_blank');
                        }
                    });
                }
            };

            if(typeof self.config.__setup === 'boolean' && !self.config.__setup && window.hsInEditor && (self.config.__product !== 'brix' || hasBrixModules)) {
                self.widgets.renderBanner(
                    `Some modules on this page require <a href="https://booya.io/" target="_blank">Booya</a> to work. | <a href="https://go.booya.io" target="_blank">Configure</a> | <a href="https://support.inboundlabs.co/en/brix-get-started-with-booya" target="_blank">Help</a>`,
                    self.widgets.banners.WARN,
                );
                initEditorBannerLinks();
            }

            if(isBrix) {
                const mode = window.booyaConfig && window.booyaConfig.__mode || 'live',
                    version = window.booyaConfig && window.booyaConfig.__version || 'latest';

                const dateNow = new Date(),
                    cacheTag = `${dateNow.getFullYear()}-${dateNow.getMonth()}-${dateNow.getDate()}@${dateNow.getHours()}`;

                const head = $('head');
                let link = document.createElement('link');
                link.rel = 'stylesheet';
                link.href = mode === 'local-assets'?'../dist/css/booya-brix.css':`https://cdn.jsdelivr.net/npm/@inboundlabs/booya-ui@${version}/dist/css/booya-brix.min.css?ctag=${encodeURIComponent(cacheTag)}`;
                const title = head.find('title');
                if(title.length) {
                    title.after(link);
                } else {
                    head.prepend(link);
                }

                const hubspotScopes = self.config.hubspot && self.config.hubspot.scopes || [];
                if(window.hsInEditor && self.config.__setup && !hubspotScopes.includes('tickets') && /name: "ticket",/.test($('.brix-dashboard-object-wrapper').next('script').html())) {
                    const matches = /https?:\/\/preview.hs-sites.com\/_hcms\/preview\/content\/(?<page_id>\d+).*portalId=(?<portal_id>\d+)/i.exec(window.location.href);
                    let editorUrl = null;
                    if(matches && matches.groups && matches.groups.page_id && matches.groups.portal_id) {
                        editorUrl = `https://app.hubspot.com/content/${matches.groups.portal_id}/edit/${matches.groups.page_id}/content`;
                    }

                    self.widgets.renderBanner(
                        `Some modules on this page require <a href="https://booya.io/" target="_blank">Booya</a> to have access to HubSpot tickets and/or custom objects to work. | <a href="https://go.booya.io/connect/hubspot/add?app_id=${encodeURIComponent(self.config.appID)}&scopes=${encodeURIComponent('tickets content hubdb crm.objects.custom.read e-commerce')}&redirect_url=${encodeURIComponent(editorUrl || window.location.href)}" target="_blank">Configure</a> | <a href="https://support.inboundlabs.co/en/brix-get-started-with-booya" target="_blank">Help</a>`,
                        self.widgets.banners.WARN,
                    );
                    initEditorBannerLinks();
                }
            }

            $(document).ready(function () {
                if(self.config.portalID && self.config.appID) {
                    // Set instance state to ready
                    self.isReady = true;

                    // Trigger ready event
                    self.trigger(self.events.READY);

                    // Initialize Booya
                    self.init();
                }
            });
        }

        if(typeof self.config.__setup === 'boolean' && self.config.context && self.config.context.domain) {
            completeInitialization();
        } else if(self.config.appID || self.config.portalID) {
            $.ajax({
                url: `${self.config.appID?self.getAPIEndpointURL('/config'):`${self.getAPIBaseURL()}/config/${self.config.portalID}`}?version=${window.booyaConfig.__version || ''}&platform=${window.booyaConfig.__platform || ''}&product=${window.booyaConfig.__product || ''}&url=${encodeURIComponent(location.href)}`,
                type: "GET",
                dataType: 'json',
                xhrFields: {
                    withCredentials: true
                }
            }).done(function (data) {
                self.setConfig({
                    ...(data || {}),
                    __setup: true,
                });

                completeInitialization();
            }).fail(function (error) {
                if (error && error.responseText) {
                    let data = $.parseJSON(error.responseText);
                    if (data) {
                        if(data.reason === 'not_setup') {
                            self.setConfig({
                                __setup: false,
                            });
                        }

                        if(data.__version) {
                            self.setConfig({
                                __version: data.__version,
                            });
                        }
                    }
                }

                completeInitialization();
            });
        }
    }

    config = window.booyaConfig || {};

    state = {
        events: [],
    };

    translations = new BooyaTranslations();

    widgets = new BooyaWidgets();

    events = {
        // Ready
        READY: 'booya-ready',
        // Register
        REGISTER_SUCCESS: 'booya-register-success',
        REGISTER_FAILED: 'booya-register-failed',
        // Login
        LOGIN_SUCCESS: 'booya-login-success',
        OAUTH_LOGIN_SUCCESS: 'booya-oauth-login-success',
        LOGIN_FAILED: 'booya-login-failed',
        // Identify
        IDENTIFY_SUCCESS: 'booya-identify-success',
        IDENTIFY_FAILED: 'booya-identify-failed',
        // Logout
        LOGOUT_SUCCESS: 'booya-logout-success',
        LOGOUT_FAILED: 'booya-logout-failed',
        // Verify Account
        VERIFY_ACCOUNT_SUCCESS: 'booya-verify-account-success',
        VERIFY_ACCOUNT_FAILED: 'booya-verify-account-success',
        // Validate account
        ACCOUNT_EXISTS_SUCCESS: 'booya-account-exists-success',
        ACCOUNT_EXISTS_FAILED: 'booya-account-exists-failed',
        // Update Profile
        PROFILE_UPDATE_SUCCESS: 'booya-profile-update-success',
        PROFILE_UPDATE_FAILED: 'booya-profile-update-failed',
        // COMPLETE PROFILE PROMPT
        COMPLETE_PROFILE_PROMPT: 'booya-complete-profile-prompt',
        EDIT_PROFILE_PROMPT: 'booya-edit-profile-prompt',
        // RECOVER
        RECOVER_SUCCESS: 'booya-recover-success',
        RECOVER_FAILED: 'booya-recover-failed',
        // RESET
        SET_PASSWORD_SUCCESS: 'booya-set-password-success',
        SET_PASSWORD_FAILED: 'booya-set-password-failed',
        // RESET
        RESET_SUCCESS: 'booya-reset-success',
        RESET_FAILED: 'booya-reset-failed',
        // MAGIC LINK
        MAGIC_LINK_REQUEST_SUCCESS: 'booya-magic-link-request-success',
        MAGIC_LINK_REQUEST_FAILED: 'booya-magic-link-request-failed',
        MAGIC_LINK_VERIFY_SUCCESS: 'booya-magic-link-verify-success',
        MAGIC_LINK_VERIFY_FAILED: 'booya-magic-link-verify-failed',
        // URL REDIRECT
        MEMBER_URL_REDIRECT: 'booya-member-url-redirect',
        GUEST_URL_REDIRECT: 'booya-guest-url-redirect',

        // Keep for legacy integrations
        VERIFY_EMAIL_SUCCESS: 'booya-account-exists-success', // Formerly: booya-verify-email-success
        VERIFY_EMAIL_FAILED: 'booya-account-exists-failed', // Formerly: booya-verify-email-failed
    };

    providers = new BooyaProviders();

    setConfig(config) {
        this.config = {
            ...(window.booyaConfig || {}),
            ...(this.config || {}),
            ...(config || {}),
            // Apply overrides
            ...(window.booyaConfig && window.booyaConfig.overrides || {}),
            ...(this.config && this.config.overrides || {}),
            ...(config && config.overrides || {}),
        };

        // Set API Root
        this.config.apiRoot = this.getAPIEndpointURL('');

        this.widgets = new BooyaWidgets();
        this.providers = new BooyaProviders();

        window.booyaConfig = this.config;
    }

    overrideConfig(config) {
        this.setConfig({
            overrides: config,
        });
    }

    setCookie(cookieName, cookieValue, expireDays, domain) {
        let expiryDate = new Date();
        expiryDate.setTime(expiryDate.getTime() + (expireDays * 24 * 60 * 60 * 1000));
        document.cookie = `${cookieName}=${cookieValue};${domain?`Domain=${domain};`:''}Path=/;expires=${expiryDate.toUTCString()};`;
    }

    deleteCookie(cookieName, domain) {
        document.cookie = `${cookieName}=;${domain?`Domain=${domain};`:''}Path=/;expires=Thu, 01 Jan 1970 00:00:00 GMT;`;
    }

    getCookie(cookieName) {
        let name = cookieName + "=";
        let decodedCookie = decodeURIComponent(document.cookie);
        let ca = decodedCookie.split(';');
        for (let i = 0; i < ca.length; i++) {
            let c = ca[i];
            while (c.charAt(0) === ' ') {
                c = c.substring(1);
            }
            if (c.indexOf(name) === 0) {
                return c.substring(name.length, c.length);
            }
        }
        return "";
    }

    getRootDomain() {
        let domain = location.hostname;
        if(domain === 'localhost' || /\d+\.\d+\.\d+\.\d+/i.test(domain)) {
            // Not a domain
            return null;
        } else if(this.config.context && this.config.context.domain) {
            return this.config.context.domain;
        } else {
            const parts = domain.split('.');
            const maxIdx = parts.length - 1;
            const isSubdomainLevel = parts.length >= 3 && (parts[maxIdx] + parts[maxIdx - 1]).length <= 5;
            return parts.splice( isSubdomainLevel ? -3 : -2 ).join('.');
        }
    }

    getUrlParameter(name) {
        name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
        let regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
        let results = regex.exec(location.search);
        return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
    }

    getQueryStringWithoutAuthParams() {
        let qParams = location.search || '';
        if(qParams) {
            for (const key of ['code', 'invitation_key', 'recovery_key', 'verification_key', 'magic_link_key']) {
                const value = this.getUrlParameter(key);
                if(value) {
                    for (const param of [
                        `${key}=${encodeURIComponent(value)}`,
                        `${key}=${value}`
                    ]) {
                        qParams = qParams.replace(`&${param}`, '')
                            .replace(param, '');
                    }
                }
            }
        }
        return qParams;
    }

    getAPIBaseURL() {
        return (this.config.__mode === 'development' ? 'http://localhost:5000' : 'https://auth.booya.io');
    }

    getAPIEndpointURL(path) {
        return this.getAPIBaseURL() + (this.config.appID ? `/${this.config.appID}` : '') + (path || '');
    }

    trigger(eventName, data) {
        const self = this;

        if(eventName === self.events.IDENTIFY_FAILED) {
            if(self.config.guestUrl) {
                function parseComparableUrl(url) {
                    return (url || '').replace(/^https?:\/\//i, '').replace(/\?.*$/i, '').replace(/#.*$/i, '');
                }

                const guestUrl = self.config.guestUrl,
                    comparableCurrentLocation = parseComparableUrl(window.location.href),
                    comparableRedirectableUrls = [self.config.memberUrl, ...(self.config.advancedMemberUrlConfig && self.config.advancedMemberUrlConfig.enabled && Array.isArray(self.config.advancedMemberUrlConfig.rules)?self.config.advancedMemberUrlConfig.rules:[]).map(i => i.url)].filter(i => i).map(i => parseComparableUrl(i));

                if(comparableRedirectableUrls.includes(comparableCurrentLocation) && parseComparableUrl(guestUrl) !== comparableCurrentLocation) {
                    const guestRedirectUrl = `${guestUrl}${location.search?`${/\?/i.test(guestUrl)?'&':'?'}${(location.search || '').replace('?', '')}`:''}`;
                    self.trigger(self.events.GUEST_URL_REDIRECT, { nextUrl: guestRedirectUrl });
                    if(!self.isEventOverridden(self.events.GUEST_URL_REDIRECT)) {
                        window.location.href = guestRedirectUrl;
                        return;
                    }
                }
            }
        }

        $.event.trigger({
            type: eventName,
            ...(data || {}),
            time: new Date()
        });
    }

    isEventOverridden(eventName) {
        return (this.state.events || []).includes(eventName);
    }

    validateForm(form) {
        const self = this;
        $('.error').remove();

        let emptyMessage = this.translations.getTranslation(this.translations.phrases.PLEASE_COMPLETE_FIELD),
            invalidURLMessage = this.translations.getTranslation(this.translations.phrases.PLEASE_ENTER_VALID_URL),
            invalidVideoURLMessage = "Please enter a Youtube, Vimeo, Wistia or Vidyard URL.",
            invalidHubSpotPartnerURLMessage = "Please enter a HubSpot Partner Directory profile URL.",
            invalidEmailMessage = this.translations.getTranslation(this.translations.phrases.PLEASE_ENTER_VALID_EMAIL),
            fileEmpty = "Please select a file.";

        function isUrlValid(url) {
            return /^(?:(?:https?|ftp):\/\/)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,})))(?::\d{2,5})?(?:\/\S*)?$/i.test(url);
        }

        function isEmailValid(email) {
            return /^\w+([^@\s]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,})+$/.test(email);
        }

        function isVideoUrlValid(url) {
            return /https?:\/\/(.*youtube\.com\/watch.*|.*\.youtube\.com\/v\/.*|youtu\.be\/.*|.*\.youtube\.com\/user\/.*|.*\.youtube\.com\/.*#.*\/.*|m\.youtube\.com\/watch.*|m\.youtube\.com\/index.*|.*\.youtube\.com\/profile.*|.*\.youtube\.com\/view_play_list.*|.*\.youtube\.com\/playlist.*|www\.youtube\.com\/embed\/.*|youtube\.com\/gif.*|www\.youtube\.com\/gif.*|www\.youtube\.com\/attribution_link.*|youtube\.com\/attribution_link.*|youtube\.ca\/.*|youtube\.jp\/.*|youtube\.com\.br\/.*|youtube\.co\.uk\/.*|youtube\.nl\/.*|youtube\.pl\/.*|youtube\.es\/.*|youtube\.ie\/.*|it\.youtube\.com\/.*|youtube\.fr\/.*|www\.vimeo\.com\/groups\/.*\/videos\/.*|www\.vimeo\.com\/.*|vimeo\.com\/groups\/.*\/videos\/.*|vimeo\.com\/.*|vimeo\.com\/m\/#\/.*|player\.vimeo\.com\/.*|app\.wistia\.com\/embed\/medias\/.*|wistia\.com\/.*|.*\.wistia\.com\/.*|.*\.wi\.st\/.*|wi\.st\/.*|.*vidyard\.com\/.*)/i.test(url);
        }

        function isHubSpotPartnerUrlValid(url) {
            return /https?:\/\/www\.hubspot\.com\/agencies\/.+/i.test(url);
        }

        // Clear all errors
        form.find('fieldset .error').remove();
        form.find('fieldset').removeClass('has-error');

        form.find('[required] input[type="text"], [required] input[type="password"], [required] textarea, [required] select').each(function () {
            let textValue = $(this).val(),
                characterLimit = parseInt($(this).data('character-limit')),
                wordLimit = parseInt($(this).data('word-limit')),
                limitError = '';

            if (characterLimit && textValue.split().length > characterLimit) {
                limitError = self.translations.getTranslation(characterLimit === 1?self.translations.phrases.THIS_MORE_CHARACTER:self.translations.phrases.THIS_MORE_CHARACTERS, {number: characterLimit});
            } else if (wordLimit && textValue.split(' ').length > wordLimit) {
                limitError = self.translations.getTranslation(wordLimit === 1?self.translations.phrases.THIS_MORE_WORD:self.translations.phrases.THIS_MORE_WORDS, {number: wordLimit});
            }

            if (!textValue) {
                $(this).closest('fieldset').append('<div class="error">' + (limitError || emptyMessage) + '</div>');
                $(this).closest('fieldset').addClass('has-error');
            } else if ($(this).attr('type') === 'password' && (form.attr('name') === 'signup' || $(this).attr('name') === 'new_password' || $(this).attr('name') === 'confirm_password')) {
                if($(this).attr('name') === 'confirm_password') {
                    if(textValue !== form.find('[type="password"]:not([name="confirm_password"])').val()) {
                        $(this).closest('fieldset').append('<div class="error">Passwords don\'t match</div>');
                        $(this).closest('fieldset').addClass('has-error');
                    }
                } else {
                    let passwordErrorMsgs = [];
                    const passwordLengthLimit = parseInt(booyaConfig && booyaConfig.passwordSettings && booyaConfig.passwordSettings.length) || 6,
                        passwordDigits = booyaConfig && booyaConfig.passwordSettings && booyaConfig.passwordSettings.digits || false,
                        passwordLowercase = booyaConfig && booyaConfig.passwordSettings && booyaConfig.passwordSettings.lowercase || false,
                        passwordUppercase = booyaConfig && booyaConfig.passwordSettings && booyaConfig.passwordSettings.uppercase || false,
                        passwordSpecial = booyaConfig && booyaConfig.passwordSettings && booyaConfig.passwordSettings.special || false,
                        passwordNoProfileInfo = booyaConfig && booyaConfig.passwordSettings && booyaConfig.passwordSettings.noProfileInfo || false,
                        passwordBlacklist = booyaConfig && booyaConfig.passwordSettings && booyaConfig.passwordSettings.blacklist || '';

                    if(textValue.split('').length < passwordLengthLimit) {
                        passwordErrorMsgs.push(self.translations.getTranslation(passwordLengthLimit === 1?self.translations.phrases.PASSWORD_AT_LEAST_CHARACTER:self.translations.phrases.PASSWORD_AT_LEAST_CHARACTERS, {number: passwordLengthLimit}));
                    }

                    for (let [isEnabled, regex, errorMsg] of [
                        [passwordDigits, /\d/i, self.translations.getTranslation(self.translations.phrases.PASSWORD_MUST_CONTAIN_DIGIT)],
                        [passwordLowercase, /[a-z]/, self.translations.getTranslation(self.translations.phrases.PASSWORD_MUST_CONTAIN_LOWERCASE_LETTER)],
                        [passwordUppercase, /[A-Z]/, self.translations.getTranslation(self.translations.phrases.PASSWORD_MUST_CONTAIN_UPPERCASE_LETTER)],
                        [passwordSpecial, /[^A-Za-z0-9]/i, self.translations.getTranslation(self.translations.phrases.PASSWORD_MUST_CONTAIN_SPECIAL_CHARACTERS)],
                    ]) {
                        if(isEnabled && !regex.test(textValue)) {
                            passwordErrorMsgs.push(errorMsg);
                        }
                    }

                    if(passwordNoProfileInfo) {
                        let profileInfo = [];
                        for (let profileValue of [
                            form.find('input[name="first_name"]').val(),
                            form.find('input[name="last_name"]').val(),
                            (form.find('input[name="email"]').val() || '').replace(/@.*/i, ''),
                            window.user && window.user.first_name || '',
                            window.user && window.user.last_name || '',
                            (window.user && window.user.email || '').replace(/@.*/i, ''),
                        ].filter(i => (i || '').trim())) {
                            profileInfo = profileInfo.concat(profileValue.split(/\s/).join('|'));
                        }

                        for (let profileWord of profileInfo) {
                            if((new RegExp(profileWord, 'i')).test(textValue)) {
                                passwordErrorMsgs.push(self.translations.getTranslation(self.translations.phrases.PASSWORD_CANT_CONTAIN_WORD, {word: profileWord}));
                            }
                        }
                    }

                    if(passwordBlacklist) {
                        const blacklistWords = (passwordBlacklist || '').split(',').filter(i => (i || '').trim());
                        for (let badWord of blacklistWords) {
                            if((new RegExp(badWord, 'i')).test(textValue)) {
                                passwordErrorMsgs.push(self.translations.getTranslation(self.translations.phrases.PASSWORD_CANT_CONTAIN_WORD, {word: badWord}));
                            }
                        }
                    }

                    if(passwordErrorMsgs.length) {
                        $(this).closest('fieldset').append(
                            '<div class="error '+(passwordErrorMsgs.length > 1?'multiple-errors':'')+'">'+ (passwordErrorMsgs.length === 1?passwordErrorMsgs[0]:'<ul>'+passwordErrorMsgs.map(msg => `<li>${msg}</li>`).join('')+'</ul>') + '</div>'
                        );
                        $(this).closest('fieldset').addClass('has-error');
                    }
                }
            }
        });

        form.find('input[type="url"]').each(function () {
            let urlValue = $(this).val(),
                isRequired = $(this).parents('[required]').length,
                inputName = $(this).attr('name');

            if (!urlValue && isRequired) {
                $(this).closest('fieldset').append('<div class="error">' + emptyMessage + '</div>');
                $(this).closest('fieldset').addClass('has-error');
            } else if (urlValue) {
                if (!isUrlValid(urlValue)) {
                    $(this).closest('fieldset').append('<div class="error">' + invalidURLMessage + '</div>');
                    $(this).closest('fieldset').addClass('has-error');
                } else if (inputName === 'video' && !isVideoUrlValid(urlValue)) {
                    $(this).closest('fieldset').append('<div class="error">' + invalidVideoURLMessage + '</div>');
                    $(this).closest('fieldset').addClass('has-error');
                } else if (inputName === 'partner_directory_url' && !isHubSpotPartnerUrlValid(urlValue)) {
                    $(this).closest('fieldset').append('<div class="error">' + invalidHubSpotPartnerURLMessage + '</div>');
                    $(this).closest('fieldset').addClass('has-error');
                }
            }
        });

        form.find('[required] input[type="email"]').each(function () {
            let emailValue = $(this).val();
            if (!emailValue) {
                $(this).closest('fieldset').append('<div class="error">' + emptyMessage + '</div>');
                $(this).closest('fieldset').addClass('has-error');
            } else if (!isEmailValid(emailValue)) {
                $(this).closest('fieldset').append('<div class="error">' + invalidEmailMessage + '</div>');
                $(this).closest('fieldset').addClass('has-error');
            }
        });

        form.find('[required] input[type="file"]').each(function () {
            let fileValue = $(this).val(),
                customErrorMsg = $(this).data('error-msg');
            if (!fileValue || customErrorMsg) {
                $(this).closest('fieldset').append('<div class="error">' + (customErrorMsg || fileEmpty) + '</div>');
                $(this).closest('fieldset').addClass('has-error');
            }
        });

        form.find('[required] input[type="checkbox"]').each(function () {
            if (!$(this).prop('checked')) {
                $(this).closest('fieldset').append(`<div class="error">${emptyMessage}</div>`);
                $(this).closest('fieldset').addClass('has-error');
            }
        });

        return !(form.find('fieldset .error').length >= 1);
    }

    submitHubSpotForm(portalId, formId, utk, data, legalConsent=null) {
        let hsData = {
            fields: data,
        };
        if (utk) {
            hsData.context = {
                hutk: utk
            };
        }
        if(legalConsent) {
            let parsedLegalConsentOptions = {};
            if(legalConsent.legitimateInterest && typeof legalConsent.legitimateInterest === 'object') {
                parsedLegalConsentOptions.legitimateInterest = legalConsent.legitimateInterest;
            }

            let communicationsChoices = [];
            if(legalConsent.communications) {
                if(Array.isArray(legalConsent.communications)) {
                    communicationsChoices = legalConsent.communications;
                } else if(typeof legalConsent.communications && legalConsent.subscriptionTypeId) {
                    communicationsChoices.push({
                        value: true,
                        subscriptionTypeId: legalConsent.subscriptionTypeId,
                        text: legalConsent.communicationsText,
                    });
                }
            }

            let processingConsent = null;
            if(legalConsent.processing && typeof legalConsent.processing === 'object') {
                processingConsent = legalConsent.processing;
            } else if(legalConsent.process) {
                processingConsent = {
                    consentToProcess: true,
                    text: legalConsent.processText,
                };
            }

            const hasCommunications = (communicationsChoices && communicationsChoices.length);
            if(hasCommunications || processingConsent) {
                parsedLegalConsentOptions.consent = {};
                if(hasCommunications) {
                    parsedLegalConsentOptions.consent.communications = communicationsChoices;
                }
                if(processingConsent) {
                    parsedLegalConsentOptions.consent = {
                        ...hsData.legalConsentOptions.consent,
                        ...processingConsent,
                    };
                }
            }
            if(Object.keys(parsedLegalConsentOptions).length > 0) {
                hsData.legalConsentOptions = parsedLegalConsentOptions;
            }
        }

        return $.ajax({
            url: 'https://api.hsforms.com/submissions/v3/integration/submit/' + portalId + '/' + formId,
            type: "POST",
            data: JSON.stringify(hsData),
            contentType: 'application/json',
            processData: false,
            dataType: 'json',
        });
    }

    identifyHubSpotUser(email, callback) {
        const self = this,
            utk = self.getCookie('hubspotutk'),
            verificationFormId = (self.config && self.config.hubspot && self.config.hubspot.formIds && self.config.hubspot.formIds.verification) || null,
            cleanedCallback = typeof callback === 'function'?callback:() => {};

        const refreshIdentity = (resetCookies=false) => {
            if(resetCookies) {
                // HS set cookies on root domain
                let rootDomain = self.getRootDomain();
                if(rootDomain) {
                    rootDomain = `.${rootDomain}`;
                }
                self.deleteCookie('hubspotutk', rootDomain);
                // Need to delete other hubspot session cookies otherwise same utk will be regenerated
                // https://community.hubspot.com/t5/APIs-Integrations/Reset-identity-via-js-api/td-p/225326
                // https://knowledge.hubspot.com/reports/what-cookies-does-hubspot-set-in-a-visitor-s-browser
                self.deleteCookie('__hstc', rootDomain);
            }
            if(self.config.portalID) {
                // Submit form to identify user with hubspot
                self.submitHubSpotForm(self.config.portalID, verificationFormId, resetCookies?null:utk, [
                    {
                        name: 'email',
                        value: email,
                    }
                ]).done(function (data) {
                    cleanedCallback(true);
                }).fail(function (error) {
                    cleanedCallback(false);
                });
            } else {
                cleanedCallback(false);
            }
        };

        if(utk) {
            $.ajax({
                url: self.getAPIEndpointURL('/auth/hubspot/contact/utk/verify?utk='+encodeURIComponent(utk)),
                type: "GET",
                dataType: 'json',
                xhrFields: {
                    withCredentials: true
                }
            }).done(function (data) {
                const isValid = data && data.isValid,
                    isContact = data && data.isContact;
                if(isValid) {
                    // user token is valid, no need to refresh
                    cleanedCallback(false);
                } else {
                    refreshIdentity(isContact);
                }
            }).fail(function (error) {
                refreshIdentity(false);
            });
        } else {
            refreshIdentity(false);
        }
    }

    logOut() {
        const self = this,
            authToken = localStorage.getItem('booyaToken');

        $.ajax({
            url: self.getAPIEndpointURL('/auth/logout'),
            type: "POST",
            ...(authToken?{data: `token=${authToken}`}:{}),
            dataType: 'json',
            xhrFields: {
                withCredentials: true
            }
        }).done(function (data) {
            window.user = null;
            localStorage.removeItem('booyaToken');
            self.setCookie('booyaToken', '');
            self.setCookie('booyaTemplateToken', '');
            self.trigger(self.events.LOGOUT_SUCCESS);

            if(!self.isEventOverridden(self.events.LOGOUT_SUCCESS)) {
                if(self.config.guestUrl) {
                    location.href = self.config.guestUrl;
                } else {
                    location.reload();
                }
            }
        }).fail(function (error) {
            self.trigger(self.events.LOGOUT_FAILED);
        });
    }

    verifyUser() {
        const self = this,
            authToken = localStorage.getItem('booyaToken'),
            code = this.getUrlParameter('code'),
            verificationKey = self.getUrlParameter('verification_key'),
            magicLinkKey = self.getUrlParameter('magic_link_key'),
            isVerified = localStorage.getItem('booyaVerified');

        let token = (code && /^btc-.+/.test(code))?code:authToken;

        const showAndClearVerified = () => {
            self.widgets.renderAccountVerifiedBanner();
            localStorage.removeItem('booyaVerified');
        };

        $.ajax({
            url: self.getAPIEndpointURL('/auth/verify'),
            ...(token?{
                type: "POST",
                data: 'token=' + token
            }:{
                type: "GET",
            }),
            dataType: 'json',
            xhrFields: {
                withCredentials: true
            }
        }).done(function (data) {
            if (data.user) {
                window.user = data.user;

                if(data.token) {
                    localStorage.setItem('booyaToken', data.token);
                    self.setCookie('booyaToken', data.token);
                    if(data.template_token) {
                        self.setCookie('booyaTemplateToken', data.template_token);
                    }
                    if(code) {
                        // Remove code from URL
                        history.replaceState(null, "", location.pathname + self.getQueryStringWithoutAuthParams());

                        if(token === code) {
                            // User just logged in with OAuth
                            self.trigger(self.events.OAUTH_LOGIN_SUCCESS);
                        }
                    }
                }

                function parseComparableUrl(url) {
                    return (url || '').replace(/^https?:\/\//i, '').replace(/\?.*$/i, '').replace(/#.*$/i, '');
                }

                let dedicatedMemberUrl = '';
                if(data && data.user && self.config && self.config.advancedMemberUrlConfig && self.config.advancedMemberUrlConfig.enabled && Array.isArray(self.config.advancedMemberUrlConfig.rules)) {
                    for (let rule of self.config.advancedMemberUrlConfig.rules) {
                        if(!dedicatedMemberUrl && rule.name && rule.value && rule.url && data.user[rule.name] === rule.value) {
                            dedicatedMemberUrl = rule.url;
                        }
                    }
                }

                if(!dedicatedMemberUrl && self.config.memberUrl) {
                    dedicatedMemberUrl = self.config.memberUrl;
                }

                if(dedicatedMemberUrl) {
                    const comparableCurrentLocation = parseComparableUrl(window.location.href),
                        comparableRedirectableUrls = [self.config.guestUrl, self.config.memberUrl, ...(self.config.advancedMemberUrlConfig && self.config.advancedMemberUrlConfig.enabled && Array.isArray(self.config.advancedMemberUrlConfig.rules)?self.config.advancedMemberUrlConfig.rules:[]).map(i => i.url)].filter(i => i).map(i => parseComparableUrl(i));

                    if(((!self.config.guestUrl && /\/(login|signin)([\/?#]|$)/i.test(location.pathname)) || comparableRedirectableUrls.includes(comparableCurrentLocation)) && parseComparableUrl(dedicatedMemberUrl) !== comparableCurrentLocation) {
                        const memberRedirectUrl = `${dedicatedMemberUrl}${location.search?`${/\?/i.test(dedicatedMemberUrl)?'&':'?'}${(location.search || '').replace('?', '')}`:''}`;
                        self.trigger(self.events.MEMBER_URL_REDIRECT, { user: data && data.user || null, nextUrl: memberRedirectUrl });
                        if(!self.isEventOverridden(self.events.MEMBER_URL_REDIRECT)) {
                            window.location.href = memberRedirectUrl;
                            return;
                        }
                    }
                }

                let user = data.user;

                /* Identify User in HubSpot */
                if (user.email) {
                    self.identifyHubSpotUser(user.email);

                    // Set email in hubspot forms
                    const setHubSpotFormEmails = () => {
                        const emailInputSelector = 'form.hs-form .hs-form-field.hs-email input.hs-input[type="email"]';
                        $(emailInputSelector, $('.hbspt-form iframe.hs-form-iframe').contents()).val(user.email);
                        $(emailInputSelector).val(user.email);
                    };
                    setHubSpotFormEmails();
                    setTimeout(setHubSpotFormEmails, 200);
                }

                self.trigger(self.events.IDENTIFY_SUCCESS, {user: user});

                // Prompt user for email verification
                if (user.email && user.not_verified && !self.getUrlParameter('verification_key')) {
                    const resendSelector = '__booya-email--verification-resend';
                    let verificationMessage = self.translations.getTranslation(self.translations.phrases.YOUR_EMAIL_NOT_VERIFIED_CHECK_INBOX, {
                        email: user.email,
                        link_open: '<a href="#" class="' + resendSelector+ '">',
                        link_close: "</a>"
                    });

                    self.widgets.renderBanner(verificationMessage, self.widgets.banners.DANGER, true);

                    initVerificationEmailSender();

                    function initVerificationEmailSender() {
                        $('.'+resendSelector).off('click').click(function (e) {
                            e.preventDefault();
                            const verificationBannerWrapper = $(this).closest('.__booya-banner');
                            const verificationMessageWrapper = verificationBannerWrapper.find('.__booya-banner-message')
                            verificationMessageWrapper.html('Sending ...');

                            let payload = 'email=' + user.email + '&next_url=' + (self.getUrlParameter('next') || location.href);
                            const lang = self.translations.resolvedLanguage();
                            if(lang) {
                                payload = `${payload}&lang=${lang}`;
                            }

                            $.ajax({
                                url: self.getAPIEndpointURL("/auth/resend-verification/"),
                                type: "POST",
                                data: payload,
                                dataType: 'json',
                                xhrFields: {
                                    withCredentials: true
                                }
                            }).done(function (data) {
                                verificationMessageWrapper.html(
                                    self.translations.getTranslation(self.translations.phrases.ACCOUNT_VERIFICATION_SENT, {email: user.email})
                                );
                                verificationBannerWrapper.addClass('__booya-banner-success');
                                verificationBannerWrapper.removeClass('__booya-banner-danger');

                                setTimeout(function () {
                                    verificationBannerWrapper.remove();
                                }, 5000);
                            }).fail(function (error) {
                                verificationMessageWrapper.html(
                                    'Failed to resend verification email to ' + user.email + '. Please <a href="#" class="'+resendSelector+'">try again</a>'
                                );
                                initVerificationEmailSender();
                            });
                        });
                    }
                }


                if(self.config && (typeof self.config.requireCompleteProfile != 'boolean' || self.config.requireCompleteProfile)) {
                    // Prompt User to complete profile if necessary
                    let requiredFields = self.config && self.config.forms && self.config.forms.profile && self.config.forms.profile.requiredFields || null;
                    if(!Array.isArray(requiredFields) || !requiredFields.length) {
                        requiredFields = ['first_name', 'last_name'];
                    }

                    const hasMissingRequiredFields = !!(requiredFields.map(field => !user[field] && user[field] !== 0 && typeof user[field] !== 'boolean').filter(i => (i === true)).length);
                    if (hasMissingRequiredFields) {
                        self.trigger(self.events.COMPLETE_PROFILE_PROMPT);

                        if(!self.isEventOverridden(self.events.COMPLETE_PROFILE_PROMPT)) {
                            let formSelector = 'form.__booya-profile-form';
                            let form = $(formSelector);
                            if(form.length) {
                                form.replaceWith(self.widgets.renderProfileForm());
                                self.initUI();
                                form.closest(`.${self.widgets.selectors.modal}`).show();
                            } else {
                                self.widgets.renderModal(
                                    '',
                                    self.widgets.renderProfileForm(),
                                    {
                                        isOpen: true,
                                        isTop: true,
                                    },
                                )
                            }
                        }
                    }
                }
            } else if(magicLinkKey) {
                self.verifyMagicLink();
            }

            if(data.user || !magicLinkKey) {
                if(verificationKey) {
                    self.verifyAccount();
                } else if(isVerified) {
                    showAndClearVerified();
                }
            }
        }).fail(function (error) {
            if(verificationKey) {
                // Attempt to verify with verification_key
                self.verifyAccount();
            } else if(magicLinkKey){
                // Attempt to verify with magic_link_key
                self.verifyMagicLink();
            } else {
                self.trigger(self.events.IDENTIFY_FAILED);

                if(isVerified) {
                    showAndClearVerified();
                }
            }
        });
    }

    verifyAccount() {
        const self = this;
        const token = this.getUrlParameter('verification_key');

        if (token) {
            $.ajax({
                url: this.getAPIEndpointURL('/auth/verify/account'),
                type: "POST",
                data: 'token=' + token + (window.user?'':`&authenticate=true`),
                dataType: 'json',
                xhrFields: {
                    withCredentials: true
                }
            }).done(function (data) {
                // Remove key from URL
                history.replaceState(null, "", location.pathname + self.getQueryStringWithoutAuthParams());

                if(data.token) {
                    localStorage.setItem('booyaToken', data.token);
                    self.setCookie('booyaToken', data.token);
                    if(data.template_token) {
                        self.setCookie('booyaTemplateToken', data.template_token);
                    }
                } else if(!window.user) {
                    self.trigger(self.events.IDENTIFY_FAILED);
                }

                if(window.user || !data.token) {
                    // Show banner if no redirects are expected
                    self.widgets.renderAccountVerifiedBanner();
                } else {
                    // Otherwise wait for redirect/reload
                    localStorage.setItem('booyaVerified', 'true');
                }

                self.trigger(self.events.VERIFY_ACCOUNT_SUCCESS);

                if(!self.isEventOverridden(self.events.VERIFY_ACCOUNT_SUCCESS) && !window.user && data.token) {
                    // Reload to pick up new session
                    location.reload();
                }
            }).fail(function (error) {
                self.trigger(self.events.VERIFY_ACCOUNT_FAILED);
                if(!window.user) {
                    self.trigger(self.events.IDENTIFY_FAILED);
                }
            });
        }
    }

    verifyMagicLink() {
        const self = this;
        const token = this.getUrlParameter('magic_link_key');

        if (token) {
            $.ajax({
                url: this.getAPIEndpointURL('/auth/magic-link/verify'),
                type: "POST",
                data: 'token=' + token,
                dataType: 'json',
                xhrFields: {
                    withCredentials: true
                }
            }).done(function (data) {
                // Remove key from URL
                history.replaceState(null, "", location.pathname + self.getQueryStringWithoutAuthParams());

                if(data.token) {
                    localStorage.setItem('booyaToken', data.token);
                    self.setCookie('booyaToken', data.token);
                    if(data.template_token) {
                        self.setCookie('booyaTemplateToken', data.template_token);
                    }
                } else if(!window.user) {
                    self.trigger(self.events.IDENTIFY_FAILED);
                }

                self.trigger(self.events.MAGIC_LINK_VERIFY_SUCCESS);

                if(!self.isEventOverridden(self.events.MAGIC_LINK_VERIFY_SUCCESS) && !window.user && data.token) {
                    let memberRedirectUrl = '';
                    if(data && data.user && self.config && self.config.advancedMemberUrlConfig && self.config.advancedMemberUrlConfig.enabled && Array.isArray(self.config.advancedMemberUrlConfig.rules)) {
                        for (let rule of self.config.advancedMemberUrlConfig.rules) {
                            if(!memberRedirectUrl && rule.name && rule.value && rule.url && data.user[rule.name] === rule.value) {
                                memberRedirectUrl = rule.url;
                            }
                        }
                    }

                    const nextUrl = self.getUrlParameter('next');
                    if(memberRedirectUrl) {
                        self.trigger(self.events.MEMBER_URL_REDIRECT, { user: data && data.user || null, nextUrl: memberRedirectUrl });
                        if(!self.isEventOverridden(self.events.MEMBER_URL_REDIRECT)) {
                            location.href = memberRedirectUrl;
                        }
                    } else if(nextUrl) {
                        location.href = nextUrl;
                    } else if(self.config.memberUrl) {
                        location.href = self.config.memberUrl;
                    } else {
                        // Reload to pick up new session
                        location.reload();
                    }
                }
            }).fail(function (error) {
                self.trigger(self.events.MAGIC_LINK_VERIFY_FAILED);
                if(!window.user) {
                    self.trigger(self.events.IDENTIFY_FAILED);
                }
                const reason = error && error.responseJSON && error.responseJSON.reason;
                const [userId, otp] = (token || '').split(':')
                if(userId && reason && ['expired', 'invalid_or_expired'].includes(reason)) {
                    const resendButtonSelector = '__booya-magic-link-resend--button',
                        resendStatusSelector = '__booya-magic-link-resend--status',
                        resendContainerSelector = '__booya-magic-link-resend--container';
                    self.widgets.renderModal(
                        '',
                        `
<div class="${resendContainerSelector}" style="text-align: center; margin-top: -30px;">
    <div class="${resendStatusSelector}">
    ${self.widgets.renderNotice(self.translations.getTranslation(self.translations.phrases.THIS_MAGIC_LINK_INVALID_EXPIRED), self.widgets.notices.DANGER)}
    </div>
    <button class="__booya-btn ${resendButtonSelector}">
        ${self.translations.getTranslation(self.translations.phrases.REQUEST_NEW_MAGIC_LINK)}
    </button>
</div>
                        `,
                        {isOpen: true, isTop: true}
                    );

                    const resendButtonElement = $(`.${resendButtonSelector}`),
                        resendStatusElement = $(`.${resendStatusSelector}`);

                    resendButtonElement.off('click').click(function (e) {
                        e.preventDefault();
                        const nextUrl = ((self.getUrlParameter('next') || location.href) || '').replace(`magic_link_key=${encodeURIComponent(token)}`, '');
                        let payload = 'userId=' + encodeURIComponent(userId) + '&next_url=' + encodeURIComponent(nextUrl);
                        const lang = self.translations.resolvedLanguage();
                        if(lang) {
                            payload = `${payload}&lang=${lang}`;
                        }

                        resendStatusElement.html(
                            self.widgets.renderNotice(self.translations.getTranslation(self.translations.phrases.RESENDING_MAGIC_LINK), self.widgets.notices.INFO)
                        );
                        resendButtonElement.prop('disabled', true);

                        $.ajax({
                            url: self.getAPIEndpointURL("/auth/magic-link/request"),
                            type: "POST",
                            data: payload,
                            dataType: 'json',
                            xhrFields: {
                                withCredentials: true
                            }
                        }).done(function (data) {
                            resendStatusElement.html(
                                self.widgets.renderNotice(self.translations.getTranslation(self.translations.phrases.PLEASE_CHECK_INBOX_INSTRUCTIONS), self.widgets.notices.SUCCESS)
                            );
                            resendButtonElement.prop('disabled', true);

                            self.trigger(self.events.MAGIC_LINK_REQUEST_SUCCESS, {});
                        }).fail(function (error) {
                            resendStatusElement.html(
                                self.widgets.renderNotice(self.translations.getTranslation(self.translations.phrases.OOPS_RESEND_MAGIC_LINK), self.widgets.notices.DANGER)
                            );
                            resendButtonElement.prop('disabled', false);

                            self.trigger(self.events.MAGIC_LINK_REQUEST_FAILED, {});
                        });
                    });
                } else {
                    self.widgets.renderBanner('This magic link is invalid.', self.widgets.banners.DANGER);
                }
            });
        }
    }

    initSetPassword() {
        const token = this.getUrlParameter('invitation_key');
        if (token) {
            window.invitationToken = token;

            let formSelector = 'form.__booya-reset-password-form';
            let form = $(formSelector);
            if(!form.length) {
                // Redirect to reset form
                const inviteAcceptUrl = this.config && this.config.invite && this.config.invite.acceptUrl || '';
                if(inviteAcceptUrl && location.href.search(inviteAcceptUrl) === -1) {
                    location.href = `${inviteAcceptUrl}?invitation_key=${token}`;
                    return ;
                }

                $('body').append(
                    this.widgets.renderModal(
                        '',
                        this.widgets.renderSetPasswordForm(),
                        {
                            isOpen: true,
                            isTop: true,
                        },
                    )
                );
                this.initUI();
                form = $(formSelector);
            }
        }
    }

    initResetPassword() {
        const token = this.getUrlParameter('recovery_key');
        if (token) {
            window.recoveryToken = token;

            let formSelector = 'form.__booya-reset-password-form';
            let form = $(formSelector);
            if(!form.length) {
                // Redirect to reset form
                if(this.config.resetUrl && location.href.search(this.config.resetUrl) === -1) {
                    location.href = `${this.config.resetUrl}?recovery_key=${token}`;
                    return ;
                }

                $('body').append(
                    this.widgets.renderModal(
                        '',
                        this.widgets.renderResetForm(),
                        {
                            isOpen: true,
                            isTop: true,
                        },
                    )
                );
                this.initUI();
                form = $(formSelector);
            }
        }
    }

    processHubSpotProfileData(rawData) {
        const PROFILE_FIELD_MAP = {
            first_name: 'firstname',
            last_name: 'lastname',
            telephone: 'phone',
        };

        let data = [];
        $.each(rawData, function (idx, item) {
            if (item.value && !/password|LEGAL_CONSENT/i.test(item.name)) {
                data.push({
                    name: PROFILE_FIELD_MAP[item.name] || item.name,
                    value: item.value,
                });
            }
        });
        return data;
    }

    processProfileData(rawData) {
        let data = {};
        $.each(rawData, function (idx, item) {
            if (item.value && !/password|LEGAL_CONSENT/i.test(item.name)) {
                data[item.name] = item.value;
            }
        });
        return data;
    }

    initUI = () => {
        const self = this;

        /* Modals */
        $(`.${self.widgets.selectors.modal} .__booya-close`).off('click').click(function (e) {
            e.preventDefault();
            $(this).closest(`.${self.widgets.selectors.modal}`).remove();

        });

        /* Auth Widget Section Switches */
        for (let section of ['signin', 'signup', 'recover', 'magic-link']) {
            $(`.${this.widgets.selectors.authWidgetSectionSwitch}-${section}`).off('click').click(function (e) {
                e.preventDefault();
                self.widgets.openAuthWidget(section);
            });
        }

        /* Banners */
        $('.__booya-banner-close').off('click').click(function (e) {
            $(this).closest('.__booya-banner').remove();
        });

        /* Auth Forms */
        $('form.__booya-verify-form').find('button[type="submit"]').off('click').click(function (e) {
            e.preventDefault();

            let form = $(this).parents('form');

            let submitButton = $(this),
                formSuccess = form.find('.form-success'),
                formError = form.find('.form-error'),
                formValidationError = form.find('.form-validation-error'),
                originalSubmitText = submitButton.html();

            formSuccess.hide();
            formError.hide();
            formValidationError.hide();
            formError.html(formError.attr('data-error'));

            let validationCheck = self.validateForm(form);
            if (validationCheck) {
                let data = form.serialize();

                submitButton.attr('disabled', 'disabled');
                submitButton.html(self.translations.getTranslation(self.translations.phrases.VERIFYING));

                const email = form.find('input[name="email"]').val();

                $.ajax({
                    url: self.getAPIEndpointURL("/auth/verify/user"),
                    type: "POST",
                    data: data,
                    dataType: 'json',
                    xhrFields: {
                        withCredentials: true
                    }
                }).done(function (data) {
                    form.get(0).reset();

                    submitButton.html(originalSubmitText);
                    submitButton.prop('disabled', false);
                    //formSuccess.show();
                    //formError.hide();
                    //formValidationError.hide();

                    self.trigger(self.events.ACCOUNT_EXISTS_SUCCESS, { email, form: form.get(0) });
                }).fail(function (error) {
                    submitButton.html(originalSubmitText);
                    submitButton.prop('disabled', false);

                    if (error && error.responseText) {
                        let data = $.parseJSON(error.responseText);
                        if (data && data.reason) {
                            switch (data.reason) {
                                case 'blocked':
                                    formError.html(self.translations.getTranslation(self.translations.phrases.OOPS_SOMETHING_WRONG_SUPPORT));
                                    break;
                                default:
                                    break;
                            }
                        }
                    }

                    formError.show();
                    formSuccess.hide();
                    formValidationError.hide();

                    self.trigger(self.events.ACCOUNT_EXISTS_FAILED, { email, form: form.get(0) });
                });
            }
        });

        $('form.__booya-signin-form').find('button[type="submit"]').off('click').click(function (e) {
            e.preventDefault();

            let form = $(this).parents('form');

            let submitButton = $(this),
                formSuccess = form.find('.form-success'),
                formError = form.find('.form-error'),
                formValidationError = form.find('.form-validation-error'),
                originalSubmitText = submitButton.html();

            formSuccess.hide();
            formError.hide();
            formValidationError.hide();
            formError.html(formError.attr('data-error'));

            let validationCheck = self.validateForm(form);
            if (validationCheck) {
                let data = form.serialize();

                submitButton.attr('disabled', 'disabled');
                submitButton.html(self.translations.getTranslation(self.translations.phrases.VERIFYING));

                $.ajax({
                    url: self.getAPIEndpointURL("/auth/signin/"),
                    type: "POST",
                    data: data,
                    dataType: 'json',
                    xhrFields: {
                        withCredentials: true
                    }
                }).done(function (data) {
                    form.get(0).reset();

                    submitButton.html(originalSubmitText);
                    submitButton.prop('disabled', false);
                    formSuccess.show();
                    formError.hide();
                    formValidationError.hide();

                    self.widgets.closeModal(form);

                    if(data) {
                        if(data.user && data.user.email) {
                            /* Identify User in HubSpot */
                            self.identifyHubSpotUser(data.user.email);
                        }
                        if(data.token) {
                            localStorage.setItem('booyaToken', data.token);
                            self.setCookie('booyaToken', data.token);
                        }
                        if(data.template_token) {
                            self.setCookie('booyaTemplateToken', data.template_token);
                        }
                    }

                    self.trigger(self.events.LOGIN_SUCCESS, { form: form.get(0) });

                    if(!self.isEventOverridden(self.events.LOGIN_SUCCESS)) {
                        let memberRedirectUrl = '';
                        if(data && data.user && self.config && self.config.advancedMemberUrlConfig && self.config.advancedMemberUrlConfig.enabled && Array.isArray(self.config.advancedMemberUrlConfig.rules)) {
                            for (let rule of self.config.advancedMemberUrlConfig.rules) {
                                if(!memberRedirectUrl && rule.name && rule.value && rule.url && data.user[rule.name] === rule.value) {
                                    memberRedirectUrl = rule.url;
                                }
                            }
                        }

                        const nextUrl = self.getUrlParameter('next');
                        if(memberRedirectUrl) {
                            self.trigger(self.events.MEMBER_URL_REDIRECT, { user: data && data.user || null, nextUrl: memberRedirectUrl });
                            if(!self.isEventOverridden(self.events.MEMBER_URL_REDIRECT)) {
                                location.href = memberRedirectUrl;
                            }
                        } else if(nextUrl) {
                            location.href = nextUrl;
                        } else if(self.config.memberUrl) {
                            location.href = self.config.memberUrl;
                        } else {
                            location.reload();
                        }
                    }
                }).fail(function (error) {
                    submitButton.html(originalSubmitText);
                    submitButton.prop('disabled', false);

                    if (error && error.responseText) {
                        let data = $.parseJSON(error.responseText);
                        if (data && data.reason) {
                            switch (data.reason) {
                                case 'verify':
                                    formError.html(self.translations.getTranslation(self.translations.phrases.PLEASE_VERIFY_EMAIL));
                                    break;
                                case 'credentials':
                                case 'no_user':
                                    formError.html(self.translations.getTranslation(self.translations.phrases.OOPS_FIND_ACCOUNT_EMAIL_PASSWORD));
                                    break;
                                case 'blocked':
                                    formError.html(self.translations.getTranslation(self.translations.phrases.OOPS_SIGN_IN_SUPPORT));
                                    break;
                                default:
                                    break;
                            }
                        }
                    }

                    formError.show();
                    formSuccess.hide();
                    formValidationError.hide();

                    self.trigger(self.events.LOGIN_FAILED, { form: form.get(0) });
                });
            }
        });

        $('form.__booya-signup-form').find('button[type="submit"]').off('click').click(function (e) {
            e.preventDefault();

            let form = $(this).parents('form');

            let submitButton = $(this),
                formSuccess = form.find('.form-success'),
                formError = form.find('.form-error'),
                formValidationError = form.find('.form-validation-error'),
                originalSubmitText = submitButton.html();

            formSuccess.hide();
            formError.hide();
            formValidationError.hide();
            formError.html(formError.attr('data-error'));

            let validationCheck = self.validateForm(form);
            if (validationCheck) {
                let data = form.serialize();

                const nextUrl = self.getUrlParameter('next') || location.href;
                if(nextUrl){
                    data = `${data}&next_url=${nextUrl}`;
                }
                const lang = self.translations.resolvedLanguage();
                if(lang) {
                    data = `${data}&lang=${lang}`;
                }

                submitButton.attr('disabled', 'disabled');
                submitButton.html('Saving ...');

                $.ajax({
                    url: self.getAPIEndpointURL("/auth/register/"),
                    type: "POST",
                    data: data,
                    dataType: 'json',
                    xhrFields: {
                        withCredentials: true
                    }
                }).done(function (data) {
                    function completeRegistrationUpdates() {
                        // Update Form
                        form.get(0).reset();

                        submitButton.html(originalSubmitText);
                        submitButton.prop('disabled', false);
                        //formSuccess.show();
                        formError.hide();
                        formValidationError.hide();

                        self.widgets.closeModal(form);
                        self.widgets.renderBanner(
                            formSuccess.html() || self.translations.getTranslation(self.translations.phrases.ACCOUNT_CREATED_CHECK_INBOX),
                            self.widgets.banners.SUCCESS,
                        );

                        self.trigger(self.events.REGISTER_SUCCESS, { form: form.get(0) });

                        const signInAfterRegistration = (self.config && self.config.signInAfterRegistration) || null,
                            newMemberUrl = (self.config && self.config.newMemberUrl) || null;

                        if(signInAfterRegistration) {
                            if(data) {
                                if(data.user && data.user.email) {
                                    /* Identify User in HubSpot */
                                    self.identifyHubSpotUser(data.user.email);
                                }
                                if(data.token) {
                                    localStorage.setItem('booyaToken', data.token);
                                    self.setCookie('booyaToken', data.token);
                                }
                                if(data.template_token) {
                                    self.setCookie('booyaTemplateToken', data.template_token);
                                }
                            }

                            if(!self.isEventOverridden(self.events.REGISTER_SUCCESS)) {
                                if(newMemberUrl) {
                                    location.href = newMemberUrl;
                                } else {
                                    let memberRedirectUrl = '';
                                    if(data && data.user && self.config && self.config.advancedMemberUrlConfig && self.config.advancedMemberUrlConfig.enabled && Array.isArray(self.config.advancedMemberUrlConfig.rules)) {
                                        for (let rule of self.config.advancedMemberUrlConfig.rules) {
                                            if(!memberRedirectUrl && rule.name && rule.value && rule.url && data.user[rule.name] === rule.value) {
                                                memberRedirectUrl = rule.url;
                                            }
                                        }
                                    }

                                    const nextUrl = self.getUrlParameter('next');
                                    if(memberRedirectUrl) {
                                        self.trigger(self.events.MEMBER_URL_REDIRECT, { user: data && data.user || null, nextUrl: memberRedirectUrl });
                                        if(!self.isEventOverridden(self.events.MEMBER_URL_REDIRECT)) {
                                            location.href = memberRedirectUrl;
                                        }
                                    } else if(nextUrl) {
                                        location.href = nextUrl;
                                    } else if(self.config.memberUrl) {
                                        location.href = self.config.memberUrl;
                                    } else {
                                        location.reload();
                                    }
                                }
                            }
                        }
                    }

                    // Send user details to HubSpot
                    let hsData = self.processHubSpotProfileData(form.serializeArray());

                    let hubtk = self.getCookie('hubspotutk');
                    if (data) {
                        const registrationFormId = (self.config && self.config.hubspot && self.config.hubspot.formIds && self.config.hubspot.formIds.registration) || null,
                            email = data.user && data.user.email || '';

                        if (self.config.portalID && email && registrationFormId && hubtk) {
                            let legalConsentOptions = {};

                            const legalLegitimateInterest = form.find('input[name="LEGAL_CONSENT.legitimateInterest"]'),
                                legalCommunications = form.find('input[name="LEGAL_CONSENT.communication"]:checked, input[name="LEGAL_CONSENT.subscription_type"]:checked'),
                                legalProcessing = form.find('input[name="LEGAL_CONSENT.processing"]:checked');

                            if(legalLegitimateInterest.val()) {
                                legalConsentOptions.legitimateInterest = {
                                    value: true,
                                    subscriptionTypeId: parseInt(legalLegitimateInterest.val() || ''),
                                    legalBasis: legalLegitimateInterest.attr('data-legal-basis') || '',
                                    text: legalLegitimateInterest.attr('data-label'),
                                };
                            }

                            if(legalCommunications.length) {
                                let communicationSubscriptions = [];
                                $.each(legalCommunications, (idx, item) => {
                                    let checkbox = $(item);
                                    communicationSubscriptions.push({
                                        value: true,
                                        subscriptionTypeId: parseInt(checkbox.val() || ''),
                                        text: checkbox.attr('data-label'),
                                    });
                                });

                                if(communicationSubscriptions.length) {
                                    legalConsentOptions.communications = communicationSubscriptions;
                                }
                            }

                            if(legalProcessing.length) {
                                legalConsentOptions.processing = {
                                    consentToProcess: true,
                                    text: legalProcessing.attr('data-label'),
                                };
                            }

                            self.submitHubSpotForm(self.config.portalID, registrationFormId, hubtk, hsData, legalConsentOptions).done(function () {
                                completeRegistrationUpdates();
                            }).fail(function (error, data) {
                                completeRegistrationUpdates();
                            });
                        } else {
                            completeRegistrationUpdates();
                        }
                    } else {
                        completeRegistrationUpdates();
                    }
                }).fail(function (error) {
                    submitButton.html(originalSubmitText);
                    submitButton.prop('disabled', false);

                    if (error && error.responseText) {
                        let data = $.parseJSON(error.responseText);
                        if (data && data.reason) {
                            switch (data.reason) {
                                case 'exists':
                                    formError.html(self.translations.getTranslation(self.translations.phrases.ACCOUNT_EXISTS));
                                    break;
                                case 'blocked':
                                    formError.html(self.translations.getTranslation(self.translations.phrases.SORRY_CANT_SIGN_UP_SUPPORT));
                                    break;
                                default:
                                    break;
                            }
                        }
                    }

                    formError.show();
                    formSuccess.hide();
                    formValidationError.hide();

                    self.trigger(self.events.REGISTER_FAILED, { form: form.get(0) });
                });
            } else {
                submitButton.html(originalSubmitText);
                submitButton.prop('disabled', false);
                formValidationError.show();
                formError.hide();
                formSuccess.hide();
            }
        });

        $('form.__booya-profile-form').find('button[type="submit"]').off('click').click(function (e) {
            e.preventDefault();

            let form = $(this).parents('form');

            let submitButton = $(this),
                formSuccess = form.find('.form-success'),
                formError = form.find('.form-error'),
                formValidationError = form.find('.form-validation-error'),
                originalSubmitText = submitButton.html();

            formSuccess.hide();
            formError.hide();
            formValidationError.hide();

            let validationCheck = self.validateForm(form);

            const profileFormId = (self.config && self.config.hubspot && self.config.hubspot.formIds && self.config.hubspot.formIds.profile) || null,
                email = window.user && window.user.email || '';

            if (validationCheck && self.config.portalID && email && profileFormId) {
                let rawData = form.serializeArray();
                rawData.push({
                    name: 'email',
                    value: email,
                });

                let data = self.processHubSpotProfileData(rawData);

                submitButton.attr('disabled', 'disabled');
                submitButton.html('Saving ...');

                self.submitHubSpotForm(self.config.portalID, profileFormId, self.getCookie('hubspotutk') || null, data).done(function (data) {
                    //form.get(0).reset();

                    submitButton.html(originalSubmitText);
                    submitButton.prop('disabled', false);
                    formSuccess.show();
                    formError.hide();
                    formValidationError.hide();

                    const updates = self.processProfileData(form.serializeArray());
                    window.user = $.extend(window.user || {}, updates);

                    self.trigger(self.events.PROFILE_UPDATE_SUCCESS, { form: form.get(0), user: window.user, updates: updates });
                }).fail(function (error) {
                    submitButton.html(originalSubmitText);
                    submitButton.prop('disabled', false);
                    formError.show();
                    formSuccess.hide();
                    formValidationError.hide();

                    self.trigger(self.events.PROFILE_UPDATE_FAILED, { form: form.get(0) });
                });
            } else {
                submitButton.html(originalSubmitText);
                submitButton.prop('disabled', false);
                formValidationError.show();
                formError.hide();
                formSuccess.hide();
            }
        });

        $('form.__booya-recover-account-form').find('button[type="submit"]').off('click').click(function (e) {
            e.preventDefault();

            let form = $(this).parents('form');

            let submitButton = $(this),
                formSuccess = form.find('.form-success'),
                formError = form.find('.form-error'),
                formValidationError = form.find('.form-validation-error'),
                originalSubmitText = submitButton.html();

            formSuccess.hide();
            formError.hide();
            formValidationError.hide();

            let validationCheck = self.validateForm(form);
            if (validationCheck) {
                let data = form.serialize();

                const nextUrl = self.getUrlParameter('next') || location.href;
                if(nextUrl){
                    data = `${data}&next_url=${nextUrl}`;
                }
                const lang = self.translations.resolvedLanguage();
                if(lang) {
                    data = `${data}&lang=${lang}`;
                }

                submitButton.attr('disabled', 'disabled');
                submitButton.html(self.translations.getTranslation(self.translations.phrases.VERIFYING));

                $.ajax({
                    url: self.getAPIEndpointURL("/auth/recover/"),
                    type: "POST",
                    data: data,
                    dataType: 'json',
                    xhrFields: {
                        withCredentials: true
                    }
                }).done(function (data) {
                    form.get(0).reset();

                    submitButton.html(originalSubmitText);
                    submitButton.prop('disabled', false);
                    formSuccess.show();
                    formError.hide();
                    formValidationError.hide();

                    self.trigger(self.events.RECOVER_SUCCESS, { form: form.get(0) });
                }).fail(function (error, data) {
                    submitButton.html(originalSubmitText);
                    submitButton.prop('disabled', false);

                    if (error && error.responseText) {
                        let data = $.parseJSON(error.responseText);
                        if (data && data.reason) {
                            switch (data.reason) {
                                case 'no_user':
                                case 'invalid_email':
                                    formError.html(self.translations.getTranslation(self.translations.phrases.OOPS_FIND_ACCOUNT_EMAIL));
                                    break;
                                case 'blocked':
                                    formError.html(self.translations.getTranslation(self.translations.phrases.OOPS_ACCOUNT_RECOVERY_SUPPORT));
                                    break;
                                default:
                                    break;
                            }
                        }
                    }

                    formError.show();
                    formSuccess.hide();
                    formValidationError.hide();

                    self.trigger(self.events.RECOVER_FAILED, { form: form.get(0) });
                });
            }
        });

        $('form.__booya-set-password-form').find('button[type="submit"]').off('click').click(function (e) {
            e.preventDefault();

            let form = $(this).parents('form');

            let submitButton = $(this),
                formSuccess = form.find('.form-success'),
                formError = form.find('.form-error'),
                formValidationError = form.find('.form-validation-error'),
                originalSubmitText = submitButton.html();

            formSuccess.hide();
            formError.hide();
            formValidationError.hide();
            formError.html(formError.attr('data-error'));

            let validationCheck = self.validateForm(form);
            if (validationCheck) {
                let data = form.serialize();

                submitButton.attr('disabled', 'disabled');
                submitButton.html('Saving ...');

                $.ajax({
                    url: self.getAPIEndpointURL("/auth/set-password/"),
                    type: "POST",
                    data: 'token=' + encodeURIComponent(window.invitationToken) + '&' + data,
                    dataType: 'json',
                    xhrFields: {
                        withCredentials: true
                    }
                }).done(function (data) {
                    form.get(0).reset();
                    window.invitationToken = null;

                    submitButton.html(originalSubmitText);
                    submitButton.prop('disabled', false);
                    //formSuccess.show();
                    formError.hide();
                    formValidationError.hide();

                    history.replaceState(null, "", location.pathname + self.getQueryStringWithoutAuthParams());

                    self.widgets.closeModal(form);
                    self.widgets.renderTimedBanner(
                        formSuccess.html() || self.translations.getTranslation(self.translations.phrases.PASSWORD_SET_SUCCESSFULLY),
                        self.widgets.banners.SUCCESS,
                    );

                    self.trigger(self.events.SET_PASSWORD_SUCCESS, { form: form.get(0) });
                }).fail(function (error) {
                    submitButton.html(originalSubmitText);
                    submitButton.prop('disabled', false);

                    if (error && error.responseText) {
                        let data = $.parseJSON(error.responseText);
                        if (data && ['invalid_token', 'no_user'].indexOf(data.reason) > -1) {
                            formError.html(self.translations.getTranslation(self.translations.phrases.THIS_LINK_IS_INVALID_EXPIRED_SUPPORT));
                        }
                    }

                    formError.show();
                    formSuccess.hide();
                    formValidationError.hide();

                    self.trigger(self.events.SET_PASSWORD_FAILED, { form: form.get(0) });
                });
            }
        });

        $('form.__booya-reset-password-form').find('button[type="submit"]').off('click').click(function (e) {
            e.preventDefault();

            let form = $(this).parents('form');

            let submitButton = $(this),
                formSuccess = form.find('.form-success'),
                formError = form.find('.form-error'),
                formValidationError = form.find('.form-validation-error'),
                originalSubmitText = submitButton.html();

            formSuccess.hide();
            formError.hide();
            formValidationError.hide();
            formError.html(formError.attr('data-error'));

            let validationCheck = self.validateForm(form);
            if (validationCheck) {
                let data = form.serialize();

                submitButton.attr('disabled', 'disabled');
                submitButton.html('Saving ...');

                $.ajax({
                    url: self.getAPIEndpointURL("/auth/change-password/"),
                    type: "POST",
                    data: 'token=' + encodeURIComponent(window.recoveryToken) + '&' + data,
                    dataType: 'json',
                    xhrFields: {
                        withCredentials: true
                    }
                }).done(function (data) {
                    form.get(0).reset();
                    window.recoveryToken = null;

                    submitButton.html(originalSubmitText);
                    submitButton.prop('disabled', false);
                    //formSuccess.show();
                    formError.hide();
                    formValidationError.hide();

                    history.replaceState(null, "", location.pathname + self.getQueryStringWithoutAuthParams());

                    self.widgets.closeModal(form);
                    self.widgets.renderTimedBanner(
                        formSuccess.html() || self.translations.getTranslation(self.translations.phrases.PASSWORD_UPDATED_SUCCESSFULLY),
                        self.widgets.banners.SUCCESS,
                    );

                    self.trigger(self.events.RESET_SUCCESS, { form: form.get(0) });
                }).fail(function (error) {
                    submitButton.html(originalSubmitText);
                    submitButton.prop('disabled', false);

                    if (error && error.responseText) {
                        let data = $.parseJSON(error.responseText);
                        if (data && ['invalid_token', 'no_user'].indexOf(data.reason) > -1) {
                            formError.html(self.translations.getTranslation(self.translations.phrases.THIS_LINK_IS_INVALID_EXPIRED_GENERATE, {
                                link_open: "<a href='#' class='__booya-modal-switch' data-modal='__booya-modal-recover-account'>",
                                link_close: "</a>"
                            }));
                        }
                    }

                    formError.show();
                    formSuccess.hide();
                    formValidationError.hide();

                    self.trigger(self.events.RESET_FAILED, { form: form.get(0) });
                });
            }
        });

        $('form.__booya-magic-link-form').find('button[type="submit"]').off('click').click(function (e) {
            e.preventDefault();

            let form = $(this).parents('form');

            let submitButton = $(this),
                formSuccess = form.find('.form-success'),
                formError = form.find('.form-error'),
                formValidationError = form.find('.form-validation-error'),
                originalSubmitText = submitButton.html();

            formSuccess.hide();
            formError.hide();
            formValidationError.hide();

            let validationCheck = self.validateForm(form);
            if (validationCheck) {
                let data = form.serialize();
                data = data + '&next_url=' + location.href;
                const lang = self.translations.resolvedLanguage();
                if(lang) {
                    data = `${data}&lang=${lang}`;
                }
                if(self && self.config && self.config.onlyMagicLink) {
                    data = `${data}&register=true`;
                }

                submitButton.attr('disabled', 'disabled');
                submitButton.html(self.translations.getTranslation(self.translations.phrases.VERIFYING));

                $.ajax({
                    url: self.getAPIEndpointURL("/auth/magic-link/request/"),
                    type: "POST",
                    data: data,
                    dataType: 'json',
                    xhrFields: {
                        withCredentials: true
                    }
                }).done(function (data) {
                    form.get(0).reset();

                    submitButton.html(originalSubmitText);
                    submitButton.prop('disabled', false);
                    formSuccess.show();
                    formError.hide();
                    formValidationError.hide();

                    self.trigger(self.events.MAGIC_LINK_REQUEST_SUCCESS, { form: form.get(0) });
                }).fail(function (error, data) {
                    submitButton.html(originalSubmitText);
                    submitButton.prop('disabled', false);

                    if (error && error.responseText) {
                        let data = $.parseJSON(error.responseText);
                        if (data && data.reason) {
                            switch (data.reason) {
                                case 'blocked':
                                    formError.html(self.translations.getTranslation(self.translations.phrases.OOPS_SOMETHING_WRONG_SUPPORT));
                                    break;
                                default:
                                    break;
                            }
                        }
                    }

                    formError.show();
                    formSuccess.hide();
                    formValidationError.hide();

                    self.trigger(self.events.MAGIC_LINK_REQUEST_FAILED, { form: form.get(0) });
                });
            }
        });
    };

    init(config) {
        this.setConfig(config);

        // Don't initialize if integration is not setup yet
        if(!this.config.__setup) return;

        if(Array.isArray(window.booyaQueue) && window.booyaQueue.length) {
            for (let readyCallback of window.booyaQueue) {
                if(readyCallback && typeof readyCallback === 'function') {
                    this.ready(readyCallback);
                }
            }
            window.booyaQueue = [];
        }

        // Init auth components
        if(!this.isInitialized) {
            this.verifyUser();
            this.initSetPassword();
            this.initResetPassword();

            this.isInitialized = true;
        }

        this.initUI();
    }

    on(event, callback) {
        if(typeof callback === 'function') {
            $(document).on(event, function (e) {
                try {
                    callback(e);
                } catch (e) {
                    console.error(`booya: ${event} callback error =>`, e);
                }
            });

            if(!this.state.events || !Array.isArray(this.state.events)) {
                this.state.events = []
            }

            if(!this.state.events.includes(event)) {
                this.state.events.push(event);
            }
        }
    }

    ready(callback) {
        if(typeof callback === 'function') {
            if(this.isReady) {
                // trigger immediately if app is ready
                try {
                    callback();
                } catch(e) {
                    console.error(`booya: ${this.events.READY} callback error`, e);
                }
            }
            this.on(this.events.READY, callback);
        }
    }

    add(options) {
        const self = this,
            { type, name: widgetName, target, config :widgetConfig  } = options || {};
        if(type === 'widget') {
            const { settings, theme } = widgetConfig;

            const WIDGET_TYPES = {
                BLOG_POST: 'blog_post',
                COMPANY: 'company',
                CONTACT: 'contact',
                DEAL: 'deal',
                HUBDB: 'hubdb',
                LOCK: 'lock',
                MARKETING_EVENT: 'marketing_event',
                PRODUCT: 'product',
                QUOTE: 'quote',
                TICKET: 'ticket',
            }, DASHBOARD_TITLE_MAP = {
                [WIDGET_TYPES.BLOG_POST]: 'Blog Posts',
                [WIDGET_TYPES.COMPANY]: 'Company',
                [WIDGET_TYPES.CONTACT]: 'Contact Information',
                [WIDGET_TYPES.DEAL]: 'Projects',
                [WIDGET_TYPES.HUBDB]: 'Table',
                [WIDGET_TYPES.MARKETING_EVENT]: 'Events',
                [WIDGET_TYPES.PRODUCT]: 'Products',
                [WIDGET_TYPES.QUOTE]: 'Quotes',
                [WIDGET_TYPES.TICKET]: 'Tickets'
            }, DASHBOARD_NAME_MAP = {
                [WIDGET_TYPES.BLOG_POST]: 'blog post',
                [WIDGET_TYPES.COMPANY]: 'company',
                [WIDGET_TYPES.CONTACT]: 'contact',
                [WIDGET_TYPES.DEAL]: 'project',
                [WIDGET_TYPES.HUBDB]: 'table',
                [WIDGET_TYPES.MARKETING_EVENT]: 'event',
                [WIDGET_TYPES.PRODUCT]: 'product',
                [WIDGET_TYPES.QUOTE]: 'quote',
                [WIDGET_TYPES.TICKET]: 'ticket'
            };

            const removeDnDVerticalAligner = wrapper => {
                const dndModuleId = wrapper.attr('data-hs-widget-id');
                if(dndModuleId) {
                    wrapper.closest('.dnd-module').removeClass(`${dndModuleId}-vertical-alignment`);
                }
                wrapper.closest('.dnd-section').addClass('__booya-brix-dashboard-section');
            };

            const pluralize = word => {
                const regex = /y$/i;
                return regex.test(word)?`${word.replace(regex, 'ies')}`:`${word}s`;
            };

            switch (widgetName) {
                case WIDGET_TYPES.LOCK: {
                    const { anchor_font_color, button_bg_color, button_font_color, form_input_focus_border_color } = theme || {};
                    if(self.config.__product === 'brix') {
                        $('head').append(`
                        <style>
                        .__booya-link {
                          color: ${anchor_font_color} !important;
                        }
                        
                        .__booya-link:hover,
                        .__booya-link:focus {
                          color: ${anchor_font_color} !important;
                        }
                        
                        .__booya-link:active {
                          color: ${anchor_font_color} !important;
                        }
                        
                        .__booya-btn,
                        .__booya-btn:link,
                        .__booya-btn:visited {
                          color: ${button_font_color};
                          background-color: ${button_bg_color };
                        }
                        
                        .__booya-btn:hover,
                        .__booya-btn:focus {
                          color: ${button_font_color };
                          background-color: ${button_bg_color};
                        }
                        
                        form.__booya-form input:focus,
                        form.__booya-form input.focus,
                        form.__booya-form textarea:focus,
                        form.__booya-form textarea.focus,
                        form.__booya-form select:focus,
                        form.__booya-form select.focus {
                          border-color: ${form_input_focus_border_color} !important;
                          box-shadow: none !important;
                        }
                        
                        .__booya-user-widget > div > img,
                        .__booya-user-widget > img {
                          vertical-align: inherit;
                        }
                        </style>
                        `);
                    }

                    const { open_as_modal, multi_step, default_form, enabled_forms } = settings || {};

                    let authOptions = {
                        target: target || null,
                        ...(open_as_modal?{
                            modal: {isOpen: true}
                        }:{}),
                        section: default_form,
                    };

                    const { signin, signup, recover, magic_link } = enabled_forms;
                    for (let [dest, source] of [
                        ['multiStep', multi_step],
                        ['signIn', signin],
                        ['signUn', signup],
                        ['recover', recover],
                        ['magicLink', magic_link],
                    ]) {
                        if(typeof source === 'boolean') {
                            authOptions[dest] = source;
                        }
                    }

                    self.widgets.renderAuthWidgets(authOptions);
                    break;
                }
                case WIDGET_TYPES.BLOG_POST:
                case WIDGET_TYPES.COMPANY:
                case WIDGET_TYPES.CONTACT:
                case WIDGET_TYPES.DEAL:
                case WIDGET_TYPES.HUBDB:
                case WIDGET_TYPES.PRODUCT:
                case WIDGET_TYPES.QUOTE:
                case WIDGET_TYPES.TICKET: {
                    const { title, properties, table, email_field, fields } = settings || {};
                    const {
                        button_bg_color, button_font_color,
                        table_head_bg_color, table_border_color, table_head_font_color
                    } = theme || {};

                    if(self.config.__product === 'brix') {
                        $('head').append(`
                        <style>
                        .__booya-brix-badge {
                            ${button_font_color?`color: ${button_font_color}`:''};
                            ${button_bg_color?`background-color: ${button_bg_color}`:''};
                        }
                        .__booya-brix-table thead th {
                            ${table_head_bg_color?`background-color: ${table_head_bg_color}`:''};
                            ${table_border_color?`border-bottom-color: ${button_bg_color}`:''};
                            ${table_head_font_color?`color: ${table_head_font_color}`:''};
                        }
                        .__booya-brix-table.__booya-brix-table-vertical th > * {
                            ${table_head_font_color?`color: ${table_head_font_color}`:''};
                        }
                        .__booya-brix-dashboard-section .dnd-column {
                            padding: 0;
                            justify-content: flex-start !important;
                        }
                        </style>
                        `);
                    }

                    const widgetWrapper = $(target);
                    widgetWrapper.html(self.translations.getTranslation(self.translations.phrases.LOADING));

                    const isContactOrCompany = [WIDGET_TYPES.CONTACT, WIDGET_TYPES.COMPANY].includes(widgetName)?'__booya-brix-table-vertical':'';

                    const renderDashboardWidget = (response, error) => {
                        let dashboardWidgetBody = '',
                            numObjects = 0;

                        const getDynamicProperties = () => {
                            if(response && Array.isArray(response.order) && response.order.length) {
                                return response.order;
                            }
                            const properties = response && (response.properties || response.fields) || null;
                            if(properties && typeof properties === 'object' && Object.keys(properties).length) {
                                return Object.keys(properties);
                            }
                            switch(widgetName) {
                                case WIDGET_TYPES.COMPANY: {
                                    return ['name', 'domain'];
                                }
                                case WIDGET_TYPES.CONTACT: {
                                    return ['email', 'firstname', 'lastname'];
                                }
                                default: {
                                    return ['id', 'name'];
                                }
                            }
                        };

                        const getDynamicPropertyLabel = name => {
                            const properties = response && (response.properties || response.fields) || null;
                            return properties && properties[name] || name;
                        };

                        const getDynamicPropertyDisplayValue = (value, name) => {
                            const options = response && response.options || null;
                            if(options && options[name] && options[name][value]) {
                                value = options[name] && options[name][value];
                            }
                            if(Array.isArray(value)) {
                                return value.map(subValue => {
                                    return getDynamicPropertyDisplayValue(subValue, name);
                                }).join(', ');
                            } else if(value && typeof value === 'object') {
                                const firstKey = Object.keys(value)[0] || '';
                                return value.name || value.label || value.id || value[firstKey] || '';
                            }
                            return value || '';
                        };

                        const getHeaderColumns = () => {
                            let columns = [];
                            switch (widgetName) {
                                case WIDGET_TYPES.BLOG_POST: {
                                    columns = [
                                        'Title', 'Description', 'Author', 'Published', 'Tags'
                                    ];
                                    break;
                                }
                                case WIDGET_TYPES.COMPANY:
                                case WIDGET_TYPES.CONTACT: {
                                    columns = [];
                                    break;
                                }
                                case WIDGET_TYPES.DEAL: {
                                    columns = [
                                        'Name', 'Amount', 'Stage', 'Pipeline', 'Closed'
                                    ];
                                    break;
                                }
                                case WIDGET_TYPES.HUBDB: {
                                    columns = getDynamicProperties().map(name => getDynamicPropertyLabel(name));
                                    break;
                                }
                                case WIDGET_TYPES.PRODUCT: {
                                    columns = [
                                        'Name', 'Price', 'SKU', 'Updated'
                                    ];
                                    break;
                                }
                                case WIDGET_TYPES.QUOTE: {
                                    columns = [
                                        'Number', 'Title', 'Amount', 'Status', 'Expires'
                                    ];
                                    break;
                                }
                                case WIDGET_TYPES.TICKET: {
                                    columns = [
                                        'Ticket ID', 'Subject', 'Priority', 'Stage', 'Updated'
                                    ];
                                    break;
                                }
                                default:
                                    break;
                            }
                            return columns;
                        };

                        const renderDashboardHeader = () => {
                            if(isContactOrCompany) {
                                return '';
                            }
                            return `
                                <thead>
                                    ${getHeaderColumns().map(field => (`<th>${field}</th>`)).join('')}
                                </thead>
                            `;
                        };

                        const renderDashboardWidgetRow = object => {
                            switch (widgetName) {
                                case WIDGET_TYPES.BLOG_POST: {
                                    return `
                                        <tr>
                                            <td><a href="${object.properties.url}" target="_blank">${object.properties.title}</a></td>
                                            <td>${object.properties.description}</td>
                                            <td>${object.properties.author}</td>
                                            <td>${object.properties.date?(new Date(object.properties.date).toLocaleDateString()):''}</td>
                                            <td>${(object.properties.tags || []).join(', ')}</td>
                                        </tr>
                                    `;
                                }
                                case WIDGET_TYPES.COMPANY:
                                case WIDGET_TYPES.CONTACT: {
                                    return getDynamicProperties().map(name => {
                                        return `
                                            <tr>
                                                <th>${getDynamicPropertyLabel(name)}</th><td>${getDynamicPropertyDisplayValue(object.properties[name], name) || ''}</td>
                                            </tr>
                                        `;
                                    }).join('\n');
                                }
                                case WIDGET_TYPES.DEAL: {
                                    const closeDate = object.properties.closedate;
                                    return `
                                        <tr>
                                            <td>${object.properties.dealname}</td>
                                            <td>$${object.properties.amount}</td>
                                            <td>${object.properties.dealstage_label || object.properties.dealstage}</td>
                                            <td>${object.properties.pipeline_label || object.properties.pipeline}</td>
                                            <td>${closeDate?new Date(closeDate).toLocaleDateString():''}</td>
                                        </tr>
                                    `;
                                }
                                case WIDGET_TYPES.HUBDB: {
                                    return `
                                        <tr>
                                            ${getDynamicProperties().map(name => {
                                        return `<td>${getDynamicPropertyDisplayValue(object.properties[name], name) || ''}</td>`;
                                    }).join('\n')}
                                        </tr>
                                    `;
                                }
                                case WIDGET_TYPES.PRODUCT: {
                                    return `
                                        <tr>
                                            <td>${object.properties.name}</td>
                                            <td>$${object.properties.price}</td>
                                            <td>${object.properties.hs_sku}</td>
                                            <td>${new Date(object.properties.hs_lastmodifieddate || object.properties.createdate).toLocaleDateString()}</td>
                                        </tr>
                                    `;
                                }
                                case WIDGET_TYPES.QUOTE: {
                                    const expiresDate = object.properties.hs_expiration_date;
                                    return `
                                        <tr>
                                            <td>${object.properties.hs_quote_number}</td>
                                            <td>${object.properties.hs_title}</td>
                                            <td>$${object.properties.hs_quote_amount}</td>
                                            <td>${object.properties.hs_status || object.properties.hs_status}</td>
                                            <td>${expiresDate?new Date(expiresDate).toLocaleDateString():''}</td>
                                        </tr>
                                    `;
                                }
                                case WIDGET_TYPES.TICKET: {
                                    const ticketPriority = object.properties.hs_ticket_priority || '';
                                    return `
                                        <tr>
                                            <td>${object.id}</td>
                                            <td>${object.properties.subject}</td>
                                            <td><span class="__booya-brix-ticket-priority __booya-brix-ticket-priority-${ticketPriority.toLowerCase()}">${ticketPriority.substr(0, 1)}${ticketPriority.substr(1).toLowerCase()}</span></td>
                                            <td>${object.properties.hs_pipeline_stage_label || object.properties.hs_pipeline_stage}</td>
                                            <td>${new Date(object.properties.hs_lastmodifieddate || object.properties.createdate).toLocaleDateString()}</td>
                                        </tr>
                                    `;
                                }
                                default: {
                                    return '';
                                }
                            }
                        };

                        const renderDashboardWidgetStatus = message => {
                            let colspan = getHeaderColumns().length;

                            return `<tr>
                                        <td colspan="${colspan}">
                                            ${message || `No ${pluralize(widgetName === WIDGET_TYPES.HUBDB?'entry':DASHBOARD_NAME_MAP[widgetName])} found.`}
                                        </td>
                                    </tr>`;
                        };

                        if(response && response.results) {
                            numObjects = (response.results || []).length;
                            let cleanResults = (response.results || []);
                            if(isContactOrCompany) {
                                // Limit to one result
                                cleanResults = cleanResults.slice(0, 1);
                            }
                            for (let object of cleanResults) {
                                dashboardWidgetBody += renderDashboardWidgetRow(object);
                            }
                            if(!dashboardWidgetBody) {
                                dashboardWidgetBody = renderDashboardWidgetStatus();
                            }
                        }

                        if(!dashboardWidgetBody) {
                            switch (error) {
                                case 'no_permission': {
                                    dashboardWidgetBody = renderDashboardWidgetStatus(`${DASHBOARD_TITLE_MAP[widgetName]} are not set up for your account. Please contact support.`);
                                    break;
                                }
                                default: {
                                    dashboardWidgetBody = renderDashboardWidgetStatus(`Oops! We failed to load your ${pluralize(DASHBOARD_NAME_MAP[widgetName])}. Please contact support if this issue persists.`);
                                    break;
                                }
                            }
                        }

                        dashboardWidgetBody = `
                            <table class="__booya-brix-table ${[WIDGET_TYPES.COMPANY, WIDGET_TYPES.CONTACT].includes(widgetName)?'__booya-brix-table-vertical':''}">
                            ${renderDashboardHeader()}
                            <tbody>
                            ${dashboardWidgetBody}
                            </tbody>
                            </table>
                        `;

                        widgetWrapper.html(`
                            <h3>${title || DASHBOARD_TITLE_MAP[widgetName]}${numObjects && !isContactOrCompany?` <span class="__booya-brix-badge">${numObjects}</span>`:''}</h3>
                            ${dashboardWidgetBody}
                        `);

                        removeDnDVerticalAligner(widgetWrapper);
                    }

                    let qParams = [
                        `vid=${window.user && window.user.vid || ''}`,
                        `email=${window.user && window.user.email || ''}`,
                    ];
                    for (let [key, value] of [
                        ['email_field', email_field],
                        ['table', table],
                        ['properties', properties],
                        ['fields', fields],
                    ]) {
                        if(Array.isArray(value)) {
                            if(value.length) {
                                qParams.push(`${key}=${value.join(',')}`);
                            }
                        } else if(value) {
                            qParams.push(`${key}=${value}`);
                        }
                    }

                    $.ajax({
                        url: `${self.getAPIEndpointURL(`/api/hubspot/objects/${widgetName === WIDGET_TYPES.CONTACT?'my_contact':(widgetName === WIDGET_TYPES.HUBDB?WIDGET_TYPES.HUBDB:pluralize(widgetName))}`)}?${qParams.join('&')}`,
                        type: "GET",
                        dataType: 'json',
                        xhrFields: {
                            withCredentials: true
                        }
                    }).done(function (data) {
                        renderDashboardWidget(data, null);
                    }).fail(function (error) {
                        if(error && error.responseText) {
                            try {
                                let data = $.parseJSON(error.responseText);
                                return renderDashboardWidget(null, data && data.reason || 'unknown');
                            } catch (e) {
                                //
                            }
                        }
                        renderDashboardWidget(null, 'unknown');
                    });
                    break;
                }
                case WIDGET_TYPES.MARKETING_EVENT: {
                    const { title } = settings || {};

                    const widgetWrapper = $(target);
                    widgetWrapper.html(`
                        <h3>${title || DASHBOARD_TITLE_MAP[widgetName]}</h3>
                        <table class="__booya-brix-table">
                        <tbody>
                        <tr><td>Coming soon! Your ${pluralize(DASHBOARD_NAME_MAP[widgetName] || '').toLowerCase()} will appear here.</td></tr>
                        </tbody>
                        </table>
                    `);

                    removeDnDVerticalAligner(widgetWrapper);
                    break;
                }
                default:
                    break;
            }
        }
    }

    createHSChatToken(callback) {
        if(window.user && window.user.email) {
            const user = window.user;
            $.ajax({
                url: this.getAPIEndpointURL('/auth/hubspot/conversations/token'),
                type: "POST",
                data: JSON.stringify({
                    email: user.email || '',
                    firstname: user.firstname || '',
                    lastname: user.lastname || '',
                }),
                contentType: 'application/json',
                processData: false,
                dataType: 'json',
                xhrFields: {
                    withCredentials: true,
                }
            }).done(function (data) {
                callback(data && data.token || null);
            }).fail(function (error) {
                callback(null);
            });
        } else {
            callback(null);
        }
    }
}

window.booya = new Booya();